
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});

parcelRegister("gxXVf", function(module, exports) {

$parcel$export(module.exports, "openMacroBrowserForInitialConfiguration", () => $e47b9ace59ffb2ab$export$2fcab9f40bb3cea4);
$parcel$export(module.exports, "openMacroBrowserToEditExistingMacro", () => $e47b9ace59ffb2ab$export$bb0b49ebec872281);

var $lwdd5 = parcelRequire("lwdd5");

var $6OgRG = parcelRequire("6OgRG");
var $6mEZ3 = parcelRequire("6mEZ3");
var $foRF9 = parcelRequire("foRF9");
var $3IXUB = parcelRequire("3IXUB");

var $8pcS0 = parcelRequire("8pcS0");

var $fgbpl = parcelRequire("fgbpl");

var $7W8i8 = parcelRequire("7W8i8");

var $6Ywr0 = parcelRequire("6Ywr0");

var $7bL1M = parcelRequire("7bL1M");

var $bx6Tx = parcelRequire("bx6Tx");

// An empty adf node to fallback to if no selected macro is provided
const $e47b9ace59ffb2ab$var$fallbackADNode = {
    type: 'extension',
    content: (0, $8pcS0.EMPTY_ADF_CONTENT)
};
const $e47b9ace59ffb2ab$export$a40defd79158e045 = {
    showLabels: {
        value: 'true'
    },
    max: {
        value: '15'
    },
    sort: {
        value: null
    },
    showSpace: {
        value: 'true'
    },
    reverse: {
        value: 'false'
    },
    excerptType: {
        value: 'none'
    }
};
function $e47b9ace59ffb2ab$export$4793f1f3f9872794() {
    return (0, $3IXUB.getMacroMetaData)().then((macros)=>macros.filter((item)=>(0, $8pcS0.allowedMacrosForInsertMenu).includes(item.macroName)));
}
function $e47b9ace59ffb2ab$export$ace579897112f22(macroDefinition) {
    return {
        type: 'embedCard',
        attrs: {
            url: macroDefinition.params && macroDefinition.params.url,
            layout: 'wide'
        }
    };
}
const $e47b9ace59ffb2ab$var$fireAnchorAnalyticsEvent = (createAnalyticsEvent, action, contentId, nameStatus)=>{
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: action,
            actionSubject: `${action}Anchor`,
            source: 'extensions-editor',
            attributes: {
                contentId: contentId,
                nameStatus: nameStatus
            }
        }
    }).fire();
};
const $e47b9ace59ffb2ab$var$fireJIMAnalyticsEvent = (contentId, prevNodeType, newNodeType, createAnalyticsEvent)=>{
    const tableToIssueCount = prevNodeType === 'extension' && newNodeType === 'inlineExtension';
    const issueCountToTable = prevNodeType === 'inlineExtension' && newNodeType === 'extension';
    if (tableToIssueCount || issueCountToTable) createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'changedJiraIssueMacroExtensionView',
            source: 'JiraIssueMacro',
            objectId: contentId,
            attributes: {
                tableToIssueCount: tableToIssueCount,
                issueCountToTable: issueCountToTable
            }
        }
    }).fire();
};
const $e47b9ace59ffb2ab$var$fireContentByLabelAnalyticsEvent = (contentId, parameters, createAnalyticsEvent)=>{
    const getUGCFreeParameters = ()=>{
        const { cql: cql, title: title, ...rest } = parameters;
        return {
            ...$e47b9ace59ffb2ab$export$a40defd79158e045,
            ...rest
        };
    };
    if (parameters) createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'closed',
            actionSubject: 'modal',
            actionSubjectId: 'macroBrowser',
            source: 'ContentByLabel',
            objectId: contentId,
            attributes: {
                extensionKey: 'contentbylabel',
                parameters: {
                    ...getUGCFreeParameters()
                }
            }
        }
    }).fire();
};
const $e47b9ace59ffb2ab$var$fireErrorAnalytics = (contentId, actionSubject, createAnalyticsEvent, error, extensionKey)=>{
    createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            action: 'error',
            actionSubject: actionSubject,
            source: 'editor-extensions',
            objectId: contentId,
            attributes: {
                error: error?.message ?? error,
                stack: error?.stack,
                extensionKey: extensionKey
            }
        }
    }).fire();
};
async function $e47b9ace59ffb2ab$export$ff9b124c4a74b7b1(macroDefinition, isEditingMacro, extensionAnalyticsInfo) {
    if (macroDefinition.name === 'anchor') {
        const anchorNameProvidedByUser = macroDefinition.params[''];
        // Strip spaces off the beginning and end of the name
        let anchorNameWithoutSpaces = anchorNameProvidedByUser.replace(/^\s+/g, '');
        anchorNameWithoutSpaces = anchorNameWithoutSpaces.replace(/\s+$/g, '');
        // Changing any remaining spaces to '-' to match header logic
        anchorNameWithoutSpaces = anchorNameWithoutSpaces.replace(/\s+/g, '-');
        // Stripping out any single or double quotes for security (VULN-539679)
        anchorNameWithoutSpaces = anchorNameWithoutSpaces.replace(/[\"\']+/g, '');
        if (extensionAnalyticsInfo && extensionAnalyticsInfo.createAnalyticsEvent) {
            let nameStatus;
            if (anchorNameWithoutSpaces === '') nameStatus = 'missing';
            else {
                anchorNameWithoutSpaces = anchorNameWithoutSpaces.substring(0, (0, $bx6Tx.MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH));
                try {
                    decodeURIComponent(anchorNameWithoutSpaces);
                    nameStatus = 'valid';
                } catch  {
                    nameStatus = 'invalid';
                }
            }
            $e47b9ace59ffb2ab$var$fireAnchorAnalyticsEvent(extensionAnalyticsInfo.createAnalyticsEvent, extensionAnalyticsInfo.action, extensionAnalyticsInfo?.contentId, nameStatus);
        }
        return {
            type: 'inlineExtension',
            attrs: {
                extensionType: 'com.atlassian.confluence.macro.core',
                extensionKey: 'anchor',
                parameters: {
                    macroParams: {
                        '': {
                            value: anchorNameWithoutSpaces
                        }
                    },
                    macroMetadata: {
                        title: 'Anchor'
                    }
                }
            }
        };
    } else if (macroDefinition.name === 'jiraroadmap') {
        /** jiraroadmap is always in confluence/next/packages/editor-features/src/utils/smartCardOptions.ts */ if (!isEditingMacro) return $e47b9ace59ffb2ab$export$ace579897112f22(macroDefinition);
    /*
        in order to render a single issue as a smart link the following conditions must be true or we default to inlineExtension
          - issue must be from a cloud server (params.key is defined and domain must be of a cloud instance)
          - required module from monolith (applinks-bridge-for-spa) must be loaded
          - the browser origin and issue link must be in the same environment (e.g. prod and prod, staging and staging) - only an issue for devs
      */ } else if (macroDefinition.name === 'jira' && !!macroDefinition.params.key) {
        if ((0, $6Ywr0.isRequiredModuleLoaded)('confluence/jim/jira/applinks-bridge-for-spa')) try {
            const ApplinksBridge = (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).require('confluence/jim/jira/applinks-bridge-for-spa');
            const issueUrl = await ApplinksBridge.getUrlForKey(macroDefinition.params.key, macroDefinition.params.serverId);
            if (await ApplinksBridge.isCloudAppLinkFromServerId(macroDefinition.params.serverId) && issueUrl) {
                const isIssueSameEnv = issueUrl.indexOf('atlassian.net') !== -1 === ((0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).location.origin.indexOf('atlassian.net') !== -1);
                // allow smart link insertion from localhost
                if (isIssueSameEnv || false) return {
                    type: 'inlineCard',
                    attrs: {
                        url: issueUrl
                    }
                };
            }
        } catch (e) {}
    }
    return null;
}
function $e47b9ace59ffb2ab$export$e33e56a93f919d6f(macro, config, extensionAnalyticsInfo) {
    const name = macro.macroName;
    // CFE-2344: despite not having a required parameter, the children macro should open the macro browser
    // so that the user can select a parent page. Without this, on a brand new page, the children display
    // macro renders a loading state, then completely disappears and looks broken.
    // CONFDEV-62041: tasks report macro also doesn't have a required parameter, but without any parameters
    // it tries to search the entirety of Confluence for tasks and usually times out, so let's ask for parameters anyway.
    if (macro.anyParameterRequired || name === 'children' || name === 'tasks-report-macro') return $e47b9ace59ffb2ab$export$2fcab9f40bb3cea4(macro, config, undefined, extensionAnalyticsInfo);
    return (0, $foRF9.fetchMacroAttributes)({
        macroDefinition: {
            name: name,
            body: '',
            params: {}
        },
        contentId: config.contentId
    });
}
function $e47b9ace59ffb2ab$export$5f89c55fbaf728a5(selectedMacroDefinition) {
    const { name: name, body: body, params: params, defaultParameterValue: defaultParameterValue, schemaVersion: schemaVersion } = selectedMacroDefinition;
    return {
        name: name || '',
        body: body || '',
        params: params,
        defaultParameterValue: defaultParameterValue || '',
        schemaVersion: schemaVersion
    };
}
async function $e47b9ace59ffb2ab$export$367af34aacb259a2(macroDefinition, contentId, selectedMacro) {
    const newMacroNode = await (0, $foRF9.fetchMacroAttributes)({
        macroDefinition: macroDefinition,
        contentId: contentId,
        selectedMacro: null
    });
    if ((0, $fgbpl.isBodiedExtension)(newMacroNode.type)) {
        // Updating the content of the macro if it was changed with saveMacro
        // If saveMacro does not include the body, macroDefinition.body will
        // be substituted with some function
        if (typeof macroDefinition.body === 'string') {
            let convertedBody;
            try {
                convertedBody = await (0, $6mEZ3.convertBody)('storage', 'atlas_doc_format', macroDefinition.body, contentId) || '';
                newMacroNode.content = JSON.parse(convertedBody).content;
            } catch (error) {
                const logger = (0, $7W8i8.getLogger)('getMacroBrowserSettings.onComplete');
                logger.error`Can't convert provided body from storage format to ADF: ${convertedBody}`;
                // if provided body can't be converted to ADF return the previous content
                if (selectedMacro?.content) newMacroNode.content = selectedMacro?.content;
            }
        } else if (selectedMacro?.content) newMacroNode.content = selectedMacro?.content;
    }
    return newMacroNode;
}
async function $e47b9ace59ffb2ab$export$9477d47ee97b1087(macroBrowser, config, selectedMacro, macroBrowserResolve, macroBrowserReject, extensionAnalyticsInfo, onCompleteCallback, updateMacro) {
    const blocklistRestore = await (0, $6OgRG.applyBlocklist)(macroBrowser);
    let isInserting;
    let insertUpdatedMacroFailureCount = 0;
    return {
        autoClose: false,
        onComplete: async (rowMacroDefinition)=>{
            isInserting = true;
            macroBrowser.UI.showBrowserSpinner(true);
            const macroDefinition = $e47b9ace59ffb2ab$export$5f89c55fbaf728a5(rowMacroDefinition);
            try {
                let newMacroNode = await $e47b9ace59ffb2ab$export$ff9b124c4a74b7b1(macroDefinition, selectedMacro?.attrs?.extensionKey === 'jiraroadmap', extensionAnalyticsInfo);
                // If no transformation happen process as general macro
                if (!newMacroNode) {
                    newMacroNode = await $e47b9ace59ffb2ab$export$367af34aacb259a2(macroDefinition, config.contentId, selectedMacro);
                    if (selectedMacro?.attrs?.extensionKey === 'jira' && extensionAnalyticsInfo && extensionAnalyticsInfo.createAnalyticsEvent) $e47b9ace59ffb2ab$var$fireJIMAnalyticsEvent(config.contentId, selectedMacro?.type, newMacroNode?.type, extensionAnalyticsInfo?.createAnalyticsEvent);
                    if (macroDefinition?.name === 'contentbylabel' && extensionAnalyticsInfo && extensionAnalyticsInfo.createAnalyticsEvent) $e47b9ace59ffb2ab$var$fireContentByLabelAnalyticsEvent(config.contentId, newMacroNode?.attrs?.parameters?.macroParams, extensionAnalyticsInfo?.createAnalyticsEvent);
                }
                macroBrowserResolve(newMacroNode);
                macroBrowser.close();
                blocklistRestore();
                onCompleteCallback?.({
                    macro: macroDefinition?.name,
                    isBodiedExtension: (0, $fgbpl.isBodiedExtension)(newMacroNode?.type)
                });
            } catch (err) {
                if ((0, $8pcS0.MODERENIZED_MACRO_KEYS).includes(selectedMacro?.attrs?.extensionKey)) $e47b9ace59ffb2ab$var$fireErrorAnalytics(config.contentId, 'onComplete', extensionAnalyticsInfo?.createAnalyticsEvent, err, selectedMacro?.attrs?.extensionKey);
                macroBrowserReject(err);
            }
        },
        onCancel: ()=>{
            blocklistRestore();
            // Macro browser can call cancel on insert, so we need to keep state
            // and only reject when someone isn't trying to insert
            if (!isInserting) macroBrowserReject({
                reason: 'cancel'
            });
        },
        insertUpdatedMacro: async (rowMacroDefinition)=>{
            const macroDefinition = $e47b9ace59ffb2ab$export$5f89c55fbaf728a5(rowMacroDefinition);
            try {
                const newMacroNode = await $e47b9ace59ffb2ab$export$367af34aacb259a2(macroDefinition, config.contentId, selectedMacro);
                updateMacro?.(newMacroNode);
                insertUpdatedMacroFailureCount = 0;
            } catch (error) {
                insertUpdatedMacroFailureCount++;
                if (insertUpdatedMacroFailureCount > 5) {
                    insertUpdatedMacroFailureCount = 0;
                    $e47b9ace59ffb2ab$var$fireErrorAnalytics(config.contentId, 'insertUpdatedMacro', extensionAnalyticsInfo?.createAnalyticsEvent, error, selectedMacro?.attrs?.extensionKey);
                }
            }
        }
    };
}
function $e47b9ace59ffb2ab$export$bb0b49ebec872281(selectedMacro, config, macroFilter, extensionAnalyticsInfo, updateMacro, intl, isLivePagesFeatureEnabled) {
    return new Promise(async (resolve, reject)=>{
        const selectedMacroFormattedAsLegacyMacro = await (0, $6mEZ3.formatAsLegacyMacroWithOverrides)(selectedMacro || $e47b9ace59ffb2ab$var$fallbackADNode, intl, isLivePagesFeatureEnabled);
        const macroBrowser = await (0, $7bL1M.loadMacroBrowserResources)();
        // filter based on dynamic data such as feature flags
        if (macroFilter) macroBrowser.metadataList = macroBrowser.metadataList.filter(macroFilter);
        if (extensionAnalyticsInfo) extensionAnalyticsInfo.action = 'update';
        const macroBrowserSettings = await $e47b9ace59ffb2ab$export$9477d47ee97b1087(macroBrowser, config, selectedMacro, resolve, reject, extensionAnalyticsInfo, undefined, updateMacro);
        try {
            macroBrowser.open({
                ...macroBrowserSettings,
                selectedMacro: {
                    ...selectedMacroFormattedAsLegacyMacro,
                    productContext: {
                        // product context is used by connect macros, when they call /wiki/plugins/servlet/ac/{app-key}/{macro-key}
                        // this endpoint enriches the response's structuredContext field, which is used by AP.context.getContext
                        // ideally would be good to check that this is a connect macro, however, it seems
                        // that there's no information available to check that
                        'content.id': config.contentId,
                        'enrich-content-context-parameters': true
                    }
                }
            });
        } catch (err) {
            $e47b9ace59ffb2ab$var$fireErrorAnalytics(config.contentId, 'openMacroBrowserToEditExistingMacro', extensionAnalyticsInfo?.createAnalyticsEvent, err, selectedMacro?.attrs?.extensionKey);
            reject(err);
        }
    });
}
function $e47b9ace59ffb2ab$export$2fcab9f40bb3cea4(selectedMacro, config, macroFilter, extensionAnalyticsInfo, onCompleteCallback, updateMacro) {
    return new Promise(async (resolve, reject)=>{
        const macroBrowser = await (0, $7bL1M.loadMacroBrowserResources)();
        // filter based on dynamic data such as feature flags
        if (macroFilter) macroBrowser.metadataList = macroBrowser.metadataList.filter(macroFilter);
        if (extensionAnalyticsInfo) extensionAnalyticsInfo.action = 'insert';
        const macroBrowserSettings = await $e47b9ace59ffb2ab$export$9477d47ee97b1087(macroBrowser, config, selectedMacro, resolve, reject, extensionAnalyticsInfo, onCompleteCallback, updateMacro);
        try {
            macroBrowser.open({
                ...macroBrowserSettings,
                presetMacroMetadata: {
                    ...selectedMacro,
                    productContext: {
                        'content.id': config.contentId,
                        'enrich-content-context-parameters': true
                    }
                }
            });
        } catch (err) {
            $e47b9ace59ffb2ab$var$fireErrorAnalytics(config.contentId, 'openMacroBrowserForInitialConfiguration', extensionAnalyticsInfo?.createAnalyticsEvent, err, selectedMacro?.attrs?.extensionKey);
            reject(err);
        }
    });
}

});
parcelRegister("7bL1M", function(module, exports) {

$parcel$export(module.exports, "loadMacroBrowserResources", () => $eb991ea0881203b1$export$db2ef8ac15563eb4);

var $lwdd5 = parcelRequire("lwdd5");

var $dmKyV = parcelRequire("dmKyV");
const $eb991ea0881203b1$export$1a7a5965be14ecdf = ()=>[
        "wr!com.atlassian.confluence.plugins.confluence-create-content-plugin:editor-resources",
        "wr!com.atlassian.confluence.plugins.confluence-create-content-plugin:create-from-template-macro-browser-resources",
        "wr!com.atlassian.confluence.plugins.confluence-create-content-plugin:create-from-template-resources"
    ];

function $eb991ea0881203b1$export$db2ef8ac15563eb4() {
    return new Promise((resolve)=>{
        const resources = [
            // plugins contributing to macro browser will be loaded through this context.
            // `fabric-editor-macro-browser` context is found in core in case we want to add resources of other macro in future.
            "wrc!fabric-editor-macro-browser",
            // The inline task report plugin implements its own (legacy) way of loading JS overrides, hence we have to require
            // these overrides here.
            "wr!com.atlassian.confluence.plugins.confluence-inline-tasks:inline-tasks-macro-browser",
            // Jira gadgets
            "wr!com.atlassian.confluence.plugins.gadgets:macro-browser-for-gadgetsplugin",
            // these resources are necessary for create-from-template-macro to initialize and populate the template dropdown
            // copy from packages/confluence-editor/src/editor-plugins/create-from-template-macro/plugin.js
            // tinymce also did similar macro loading via packages/confluence-editor/src/editor-plugins/index.js
            ...$eb991ea0881203b1$export$1a7a5965be14ecdf()
        ];
        (0, $dmKyV.WRM).require(resources, ()=>{
            const macroBrowser = (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).require("confluence-macro-browser/macro-browser");
            (parcelRequire("jyZHv")).then((macroBrowserOverridesModule)=>{
                macroBrowserOverridesModule.default();
            }).then(()=>{
                /**
         * this is required for atlassian connect plugin to work correctly
         * e.g open custom dialog for DrawIO, Gliffy macro
         * check this repo for more info:
         * https://stash.atlassian.com/projects/AC/repos/atlassian-connect/browse
         */ // @ts-ignore TODO FIXME we really don't need typings for "window-or-global", we need to get rid of it instead
                (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).AJS.trigger("reset.rte");
                resolve(macroBrowser);
            });
        });
    });
}

});
parcelRegister("jyZHv", function(module, exports) {

let $e3e10dc916617261$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e3e10dc916617261$var$load("2wLue").then(()=>parcelRequire('74DtK'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});





parcelRegister("7okiz", function(module, exports) {

$parcel$export(module.exports, "getExtensionHandlers", () => $53f1c3cb11bcb25b$export$fe33197d44e10fcf);

var $gwFzn = parcelRequire("gwFzn");

var $lspPP = parcelRequire("lspPP");

var $k6bGh = parcelRequire("k6bGh");

var $45xzk = parcelRequire("45xzk");

var $jFmKg = parcelRequire("jFmKg");

var $atUCF = parcelRequire("atUCF");

var $9wGTI = parcelRequire("9wGTI");

var $ge2sX = parcelRequire("ge2sX");

var $aJPUt = parcelRequire("aJPUt");

var $5kjCz = parcelRequire("5kjCz");
var $4KFTW = parcelRequire("4KFTW");

var $5PGOG = parcelRequire("5PGOG");

var $fuLIO = parcelRequire("fuLIO");

var $7NX4e = parcelRequire("7NX4e");
var $bQCqI = parcelRequire("bQCqI");

var $8pcS0 = parcelRequire("8pcS0");

var $eS4Za = parcelRequire("eS4Za");

var $hMRhJ = parcelRequire("hMRhJ");

var $l86Zj = parcelRequire("l86Zj");
var $hKeSi = parcelRequire("hKeSi");
var $2LCBF = parcelRequire("2LCBF");
var $6v9Za = parcelRequire("6v9Za");

var $e1Stz = parcelRequire("e1Stz");

var $e8Lxy = parcelRequire("e8Lxy");

var $fBjVq = parcelRequire("fBjVq");

var $lBfIn = parcelRequire("lBfIn");

var $cbr0D = parcelRequire("cbr0D");

var $icKBu = parcelRequire("icKBu");

var $8YuRm = parcelRequire("8YuRm");

var $gvBC9 = parcelRequire("gvBC9");

var $4W2RN = parcelRequire("4W2RN");

var $7zb5a = parcelRequire("7zb5a");
const $53f1c3cb11bcb25b$var$context = {
    insertCss: (styles)=>styles._insertCss()
};
const $53f1c3cb11bcb25b$export$fe33197d44e10fcf = ({ adf: adf, contentId: contentId, appearance: appearance, showTemplateVariablesInPreview: showTemplateVariablesInPreview, showTemplateInputInPreview: showTemplateInputInPreview, spaceKey: spaceKey, shouldIncludeMacroHandlers: shouldIncludeMacroHandlers = true, macroRenderedOutput: macroRenderedOutput, shouldIncludeMacroWithReferencesHandlers: shouldIncludeMacroWithReferencesHandlers = false, referentialityDataSourceProvider: referentialityDataSourceProvider, fromFabricEditor: fromFabricEditor = false, isPreviewMode: isPreviewMode = false, contentType: contentType, mediaToken: mediaToken, annotationProvider: annotationProvider, isInEditorRendererView: isInEditorRendererView }, createAnalyticsEvent)=>{
    const getMacroExtensionHandler = $53f1c3cb11bcb25b$export$d1ab742fa63c927c;
    const getTemplateHandler = showTemplateInputInPreview ? (0, $cbr0D.getTemplateVariableInputExtensionHandler) : (0, $cbr0D.getTemplateExtensionHandler);
    const templateHandler = showTemplateVariablesInPreview ? {
        [(0, $8pcS0.EXTENSION_TYPE).TEMPLATE]: getTemplateHandler
    } : {};
    const macroWithReferences = shouldIncludeMacroWithReferencesHandlers ? {
        [(0, $8pcS0.EXTENSION_TYPE).MACRO_WITH_REFERENCES]: $53f1c3cb11bcb25b$export$97164d5210648f5e({
            adf: adf,
            referentialityDataSourceProvider: referentialityDataSourceProvider
        })
    } : {};
    return shouldIncludeMacroHandlers ? {
        [(0, $8pcS0.EXTENSION_TYPE).MACRO_CORE]: getMacroExtensionHandler({
            adf: adf,
            appearance: appearance,
            contentId: contentId,
            showTemplateVariablesInPreview: showTemplateVariablesInPreview,
            showTemplateInputInPreview: showTemplateInputInPreview,
            spaceKey: spaceKey,
            macroRenderedOutput: macroRenderedOutput,
            referentialityDataSourceProvider: referentialityDataSourceProvider,
            fromFabricEditor: fromFabricEditor,
            isPreviewMode: isPreviewMode,
            contentType: contentType,
            mediaToken: mediaToken,
            annotationProvider: annotationProvider,
            isInEditorRendererView: isInEditorRendererView
        }, createAnalyticsEvent),
        [(0, $8pcS0.EXTENSION_TYPE).MIGRATION]: (0, $bQCqI.getMigrationExtHandlerForRenderer)({
            contentId: contentId,
            contextProviders: {
                ClassicEditorContextProvider: (0, $k6bGh.ClassicEditorContextProviderLazyLoader)
            }
        }),
        ...macroWithReferences,
        ...templateHandler
    } : {};
};
const $53f1c3cb11bcb25b$var$providers = {
    getExtensionHandlers: $53f1c3cb11bcb25b$export$fe33197d44e10fcf,
    EditorLoaderLoader: // CONFCLOUD-72035 - Make sure we are ALWAYS including the EditorLoaderLoader when loading
    //                   legacy macros or else the attachments macro WILL NOT WORK
    $jFmKg.default
};
const $53f1c3cb11bcb25b$export$164cd9171430f0a5 = (isMacroSSRD, macroDefaultProps)=>{
    // if SSR Macros FF is disabled, page is not SSRd, or there are no macros on the page, do nothing
    if (!window.__SSR_RENDERED__ || !window?.__SSR_MACROS_INFO__) return;
    const { extensionKey: extensionKey } = macroDefaultProps;
    if (isMacroSSRD) {
        window.__SSR_MACROS_INFO__.successes[extensionKey] = (window.__SSR_MACROS_INFO__.successes[extensionKey] ?? 0) + 1;
        window.__SSR_MACROS_INFO__.successCount += 1;
    } else {
        window.__SSR_MACROS_INFO__.failures[extensionKey] = (window.__SSR_MACROS_INFO__.failures[extensionKey] ?? 0) + 1;
        window.__SSR_MACROS_INFO__.failureCount += 1;
    }
};
const $53f1c3cb11bcb25b$export$adb86c58ecb79d9c = (macroDefaultProps)=>{
    const { attributes: { macroId: macroId } } = macroDefaultProps;
    return Boolean(window?.__LEGACY_MACRO_RENDERED_OUTPUT__?.find((el)=>el.key === macroId));
};
const $53f1c3cb11bcb25b$export$97164d5210648f5e = ({ adf: adf, referentialityDataSourceProvider: referentialityDataSourceProvider })=>{
    const extensionHandlerWithReferences = (extension, extensionHandler)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4W2RN.MacroReference), {
            adf: adf,
            extensionParams: extension,
            referentialityDataSourceProvider: referentialityDataSourceProvider
        }, extensionHandler);
    };
    return extensionHandlerWithReferences;
};
const $53f1c3cb11bcb25b$export$d1ab742fa63c927c = ({ adf: adf, contentId: contentId, appearance: appearance, showTemplateVariablesInPreview: showTemplateVariablesInPreview, showTemplateInputInPreview: showTemplateInputInPreview, spaceKey: spaceKey, macroRenderedOutput: macroRenderedOutput, referentialityDataSourceProvider: referentialityDataSourceProvider, fromFabricEditor: fromFabricEditor, isPreviewMode: isPreviewMode, mediaToken: mediaToken, annotationProvider: annotationProvider, isInEditorRendererView: isInEditorRendererView }, createAnalyticsEvent)=>(0, $eS4Za.createMacroExtensionHandler)((extension, doc)=>{
        const { extensionKey: extensionKey } = extension;
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
        const macroParams = extension?.parameters?.macroParams;
        const multiBodiedExtensionActions = doc?.[0]?.actions;
        const isBodiedMacro = extension?.type === 'bodiedExtension';
        const shouldUseDebouncedLegacyMacroRenderer = isBodiedMacro && isInEditorRendererView;
        // When isInEditorRendererView is true, we are rendering the macro in the editor renderer view.
        // In this scenario adf isn't passed to the macro extension handler as prop because we do not have access to
        // the adf from where we are using the macro extension handler. We can instead get the adf from the doc object provided to the handler.
        adf = isInEditorRendererView && !adf && !!doc ? doc?.[0] : adf;
        const attributesForAnalytics = {
            extensionType: extension?.type,
            ...extensionKey === 'excerpt-include' ? {
                isExcerptNamePresent: !!macroParams?.name
            } : undefined,
            ...extensionKey === 'gadget' && macroParams?.url?.value && {
                gadgetUrl: new URL(macroParams.url.value, location.origin).pathname
            }
        };
        const redactedAttributes = extensionKey === 'redactedMacroPlaceholder' ? {
            extensionKey: macroParams?.redactedMacroPluginKey?.value || macroParams?.redactedMacroExtensionKey?.value
        } : undefined;
        const isMissingMacroParameters = macroParams?.isMissingRequiredParameters?.value;
        const contentHandler = (macroDefaultProps, cloudId, userId)=>{
            const excerptMacroProps = {
                ...macroDefaultProps,
                appearance: appearance
            };
            const macroOutput = extension?.parameters?.macroOutput;
            if (extensionKey === 'toc' && macroParams && createAnalyticsEvent) (0, $7zb5a.sendTrackingEvent)(extensionKey, macroParams, createAnalyticsEvent, contentId);
            const legacyMacroRenderer = ()=>{
                const isMacroSSRD = window.__SSR_RENDERED__ && $53f1c3cb11bcb25b$export$adb86c58ecb79d9c(macroDefaultProps) && !isMissingMacroParameters;
                $53f1c3cb11bcb25b$export$164cd9171430f0a5(isMacroSSRD, macroDefaultProps);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hMRhJ.RendererExtensionContext).Provider, {
                    value: $53f1c3cb11bcb25b$var$providers
                }, shouldUseDebouncedLegacyMacroRenderer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fuLIO.DebouncedLegacyMacroRendererQuery), {
                    ...macroDefaultProps,
                    isTemplateEditorRenderer: showTemplateVariablesInPreview,
                    macroRenderedOutputFromSSR: isMacroSSRD && macroRenderedOutput,
                    macroOutput: macroOutput,
                    isPreviewMode: isPreviewMode,
                    isInEditorRendererView: isInEditorRendererView
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fuLIO.LegacyMacroRendererQuery), {
                    ...macroDefaultProps,
                    isTemplateEditorRenderer: showTemplateVariablesInPreview,
                    macroRenderedOutputFromSSR: isMacroSSRD && macroRenderedOutput,
                    macroOutput: macroOutput,
                    isPreviewMode: isPreviewMode
                }));
            };
            switch(extensionKey){
                case 'redactedMacroPlaceholder':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $atUCF.RedactedPlaceholderExtensionHandler), {
                        ...macroDefaultProps,
                        redactedAttributes: redactedAttributes
                    });
                case 'details':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hKeSi.DetailsExtensionHandler), {
                        ...macroDefaultProps,
                        spaceKey: spaceKey,
                        Renderer: (0, $fBjVq.default),
                        isLegacyRenderer: true,
                        annotationProvider: annotationProvider
                    });
                case 'excerpt':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2LCBF.ExcerptExtensionHandler), {
                        ...excerptMacroProps,
                        spaceKey: spaceKey,
                        Renderer: (0, $fBjVq.default),
                        isLegacyRenderer: true,
                        mediaToken: mediaToken,
                        annotationProvider: annotationProvider
                    });
                case 'expand':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6v9Za.ExpandExtensionHandler), {
                        ...macroDefaultProps,
                        Renderer: (0, $fBjVq.default),
                        annotationProvider: annotationProvider,
                        isLegacyRenderer: true
                    });
                case 'create-from-template':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $icKBu.CreateFromTemplateHandler), {
                        hasADF: !!adf,
                        macroDefaultProps: macroDefaultProps,
                        cloudId: cloudId,
                        userId: userId,
                        isPreviewMode: isPreviewMode,
                        shouldLoadAfterPaint: fromFabricEditor
                    });
                case 'toc':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gvBC9.TableOfContentsHandler), {
                        adf: adf,
                        macroDefaultProps: macroDefaultProps,
                        cloudId: cloudId,
                        userId: userId,
                        shouldLoadAfterPaint: fromFabricEditor
                    });
                case 'livesearch':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8YuRm.LiveSearchHandler), {
                        hasADF: !!adf,
                        macroDefaultProps: macroDefaultProps,
                        shouldLoadAfterPaint: fromFabricEditor
                    });
                case 'anchor':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $l86Zj.AnchorExtensionHandler), {
                        ...macroDefaultProps,
                        isSSR: false
                    });
                case 'excerpt-include':
                    if (contentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $45xzk.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7NX4e.ExcerptIncludeExtensionHandler), {
                        ...macroDefaultProps,
                        Renderer: (0, $e8Lxy.PageContentRenderer)
                    }));
                case 'detailssummary':
                    return (0, $9wGTI.fg)('confluence_ppr_adf_rendering') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $45xzk.ClassicEditorContextProviderLoader), {
                        isWithinEditor: false
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e1Stz.PagePropertiesReportRenderer), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: macroParams
                    })) : legacyMacroRenderer();
                case 'profile-picture':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5PGOG.ProfilePictureMacroHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams
                    });
                case 'profile':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5PGOG.UserProfileMacroHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams
                    });
                // generic macro renderer
                default:
                    return legacyMacroRenderer();
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4W2RN.MacroReference), {
            adf: adf,
            extensionParams: extension,
            referentialityDataSourceProvider: referentialityDataSourceProvider
        }, ({ references: references })=>{
            const macroDefaultProps = {
                node: extension,
                references: references,
                contentId: contentId,
                showTemplateVariablesInPreview: showTemplateVariablesInPreview || false,
                showTemplateInputInPreview: showTemplateInputInPreview || false,
                spaceKey: spaceKey || '',
                mode: (0, $5kjCz.RENDERER),
                context: $53f1c3cb11bcb25b$var$context,
                extensionKey: extensionKey,
                attributes: attributes,
                multiBodiedExtensionActions: multiBodiedExtensionActions
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4KFTW.MacroExperienceStart), {
                contentId: contentId,
                name: (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extension),
                mode: (0, $5kjCz.RENDERER),
                extensionKey: extensionKey,
                attributes: attributes,
                timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lBfIn.MacroAnalyticsWrapper), {
                extensionKey: extensionKey,
                attributes: {
                    ...attributesForAnalytics,
                    ...redactedAttributes
                },
                node: extension
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ge2sX.SessionData), null, ({ cloudId: cloudId, userId: userId })=>contentHandler(macroDefaultProps, cloudId, userId))));
        }));
    });

});
parcelRegister("k6bGh", function(module, exports) {

$parcel$export(module.exports, "ClassicEditorContextProviderLazyLoader", () => $6ba7b2a55cef73d6$export$5fc4d24c17f7a720);

var $jmjWc = parcelRequire("jmjWc");

const $6ba7b2a55cef73d6$export$5fc4d24c17f7a720 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "yWY-m",
    name: 'ClassicEditorContextProviderLazyLoader',
    loader: ()=>(parcelRequire("ewle4"))
});

});
parcelRegister("ewle4", function(module, exports) {

let $a92484e33db0c67c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a92484e33db0c67c$var$load("cRUrz"),
    $a92484e33db0c67c$var$load("k7roz"),
    $a92484e33db0c67c$var$load("is6uI"),
    $a92484e33db0c67c$var$load("jHDh2"),
    $a92484e33db0c67c$var$load("e1cuZ"),
    $a92484e33db0c67c$var$load("cqHdp"),
    $a92484e33db0c67c$var$load("iHZci"),
    $a92484e33db0c67c$var$load("4gZEH"),
    $a92484e33db0c67c$var$load("7orLM"),
    $a92484e33db0c67c$var$load("jmPIf"),
    $a92484e33db0c67c$var$load("fNKzh"),
    $a92484e33db0c67c$var$load("9RmPP"),
    $a92484e33db0c67c$var$load("gkmZg"),
    $a92484e33db0c67c$var$load("kQvbt"),
    $a92484e33db0c67c$var$load("jQFGH"),
    $a92484e33db0c67c$var$load("fQ1rW"),
    $a92484e33db0c67c$var$load("4tUsp"),
    $a92484e33db0c67c$var$load("f96v0"),
    $a92484e33db0c67c$var$load("ev7SX"),
    $a92484e33db0c67c$var$load("2YKx2"),
    $a92484e33db0c67c$var$load("5tHTv"),
    $a92484e33db0c67c$var$load("9jsMO"),
    $a92484e33db0c67c$var$load("26IOy"),
    $a92484e33db0c67c$var$load("2nuqm"),
    $a92484e33db0c67c$var$load("giPb3"),
    $a92484e33db0c67c$var$load("ecOVI"),
    $a92484e33db0c67c$var$load("7X74w"),
    $a92484e33db0c67c$var$load("4we3T"),
    $a92484e33db0c67c$var$load("gavZG"),
    $a92484e33db0c67c$var$load("1hjmQ"),
    $a92484e33db0c67c$var$load("h4Nf7"),
    $a92484e33db0c67c$var$load("4fCJZ"),
    $a92484e33db0c67c$var$load("hzK1f"),
    $a92484e33db0c67c$var$load("fqrMn"),
    $a92484e33db0c67c$var$load("fYi1a"),
    $a92484e33db0c67c$var$load("bjzRn"),
    $a92484e33db0c67c$var$load("8mzoy"),
    $a92484e33db0c67c$var$load("7a9CL"),
    $a92484e33db0c67c$var$load("ivQYH"),
    $a92484e33db0c67c$var$load("8pE8S"),
    $a92484e33db0c67c$var$load("9Bu2S"),
    $a92484e33db0c67c$var$load("42vdC"),
    $a92484e33db0c67c$var$load("P5iE2"),
    $a92484e33db0c67c$var$load("9FBaW"),
    $a92484e33db0c67c$var$load("2JlZe"),
    $a92484e33db0c67c$var$load("2S1L6"),
    $a92484e33db0c67c$var$load("6zfzy"),
    $a92484e33db0c67c$var$load("6StWh"),
    $a92484e33db0c67c$var$load("g9CVe"),
    $a92484e33db0c67c$var$load("5wcLJ"),
    $a92484e33db0c67c$var$load("3JWH2"),
    $a92484e33db0c67c$var$load("U7y88"),
    $a92484e33db0c67c$var$load("fEx3B"),
    $a92484e33db0c67c$var$load("dJQEi"),
    $a92484e33db0c67c$var$load("j4gWN"),
    $a92484e33db0c67c$var$load("hTb35"),
    $a92484e33db0c67c$var$load("87F9B"),
    $a92484e33db0c67c$var$load("4aLlP"),
    $a92484e33db0c67c$var$load("hrAMe"),
    $a92484e33db0c67c$var$load("c6MKV"),
    $a92484e33db0c67c$var$load("aZinD"),
    $a92484e33db0c67c$var$load("6qah4"),
    $a92484e33db0c67c$var$load("d7AfU"),
    $a92484e33db0c67c$var$load("izTVQ"),
    $a92484e33db0c67c$var$load("c2N7V"),
    $a92484e33db0c67c$var$load("4xLT8"),
    $a92484e33db0c67c$var$load("fZNCx")
]).then(()=>parcelRequire('aVsFY'));

});


parcelRegister("jFmKg", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5137d66f48adfc6$export$2e2bcd8739ae039);
parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

const $e5137d66f48adfc6$var$EditorLoaderLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8A3gW",
    name: "EditorLoaderLoader",
    loader: ()=>(parcelRequire("6X3LR"))
});
var $e5137d66f48adfc6$export$2e2bcd8739ae039 = $e5137d66f48adfc6$var$EditorLoaderLoader;

});
parcelRegister("6X3LR", function(module, exports) {

let $50fb2d98d871db4c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $50fb2d98d871db4c$var$load("43hsF"),
    $50fb2d98d871db4c$var$load("i27dG")
]).then(()=>parcelRequire('8EC29'));

});


parcelRegister("atUCF", function(module, exports) {

$parcel$export(module.exports, "RedactedPlaceholderExtensionHandler", () => $93c4a623cfe89294$export$8b14718323f670aa);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $aR2Yx = parcelRequire("aR2Yx");

const $93c4a623cfe89294$export$8b14718323f670aa = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "QOMzx",
    name: "RedactedPlaceholderExtensionHandler",
    loader: async ()=>{
        const { RedactedPlaceholder: RedactedPlaceholder } = await (parcelRequire("fspUs"));
        return RedactedPlaceholder;
    },
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aR2Yx.RedactedPlaceholderComponentShadow), null)
});

});
parcelRegister("aR2Yx", function(module, exports) {

$parcel$export(module.exports, "RedactedPlaceholderComponentShadow", () => $a3bfb2f361b9631e$export$e34f51b2cfaca368);
const $a3bfb2f361b9631e$export$e34f51b2cfaca368 = ()=>null;

});

parcelRegister("fspUs", function(module, exports) {

let $b40d919f8a6b7746$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b40d919f8a6b7746$var$load("dQy5b").then(()=>parcelRequire('fcgkZ'));

});


parcelRegister("bQCqI", function(module, exports) {

$parcel$export(module.exports, "getMigrationExtHandlerForRenderer", () => $1e9e777543fb9510$export$112339158948d5ae);

var $gwFzn = parcelRequire("gwFzn");

var $lspPP = parcelRequire("lspPP");

var $eS4Za = parcelRequire("eS4Za");

var $8pcS0 = parcelRequire("8pcS0");

var $5kjCz = parcelRequire("5kjCz");
var $4KFTW = parcelRequire("4KFTW");

var $aJPUt = parcelRequire("aJPUt");

var $7y0YZ = parcelRequire("7y0YZ");

var $fVX1M = parcelRequire("fVX1M");

var $6842f = parcelRequire("6842f");
const $1e9e777543fb9510$export$112339158948d5ae = ({ contentId: contentId, contextProviders: contextProviders })=>(0, $eS4Za.createMacroExtensionHandler)((extension)=>{
        if (!extension) return null;
        const { extensionKey: extensionKey, parameters: parameters } = extension;
        const { ClassicEditorContextProvider: ClassicEditorContextProvider = ({ children: children })=>children } = contextProviders;
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
        const defaultProps = {
            contentId: contentId,
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extensionKey,
            attributes: attributes,
            node: extension
        };
        let implementation;
        switch(extensionKey){
            case (0, $8pcS0.EXTENSION_KEY).INVALID:
                // extension is rendered outside of React DOM tree and require access to the ClassicEditorContext
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(ClassicEditorContextProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7y0YZ.InvalidExtensionLoader), {
                    parameters: parameters,
                    ...defaultProps
                }));
                break;
            case (0, $8pcS0.EXTENSION_KEY).INLINE_EXTERNAL_IMAGE:
                const inlineExternalImageProps = parameters;
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fVX1M.InlineExternalImage), {
                    ...inlineExternalImageProps,
                    ...defaultProps
                });
                break;
            case (0, $8pcS0.EXTENSION_KEY).INLINE_MEDIA_IMAGE:
                const inlineMediaImageProps = parameters;
                const { link: link } = parameters;
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6842f.InlineImage), {
                    ...inlineMediaImageProps,
                    ...defaultProps,
                    link: link
                });
                break;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extension),
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extensionKey,
            attributes: attributes,
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
            contentId: contentId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lspPP.RendererActionsContext), null, implementation));
    });

});

parcelRegister("lBfIn", function(module, exports) {

$parcel$export(module.exports, "MacroAnalyticsWrapper", () => $4f09d12458901289$export$9eec8c53e410de67);

var $gwFzn = parcelRequire("gwFzn");

var $1DWH0 = parcelRequire("1DWH0");

var $78QFu = parcelRequire("78QFu");

var $2E7zk = parcelRequire("2E7zk");
const $4f09d12458901289$export$9eec8c53e410de67 = (0, $1DWH0.default)()(class extends (0, $gwFzn.Component) {
    async componentDidMount() {
        const { createAnalyticsEvent: createAnalyticsEvent, extensionKey: extensionKey, attributes: attributes, node: node } = this.props;
        if (createAnalyticsEvent) {
            const jiraHostingOption = await (0, $2E7zk.getJiraHostingOption)(extensionKey, node?.parameters?.macroParams?.serverId?.value, true);
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "viewed",
                    actionSubject: "macro",
                    actionSubjectId: extensionKey,
                    source: "viewPageScreen",
                    attributes: {
                        ...attributes,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)(),
                        jiraHostingOption: jiraHostingOption
                    }
                }
            }).fire();
        }
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, children);
    }
});

});

parcelRegister("cbr0D", function(module, exports) {

$parcel$export(module.exports, "getTemplateExtensionHandler", () => $aaaff26cb260a96a$export$fb67b4c81279b22e);
$parcel$export(module.exports, "getTemplateVariableInputExtensionHandler", () => $aaaff26cb260a96a$export$14d3630cd94f43d4);

var $gwFzn = parcelRequire("gwFzn");

var $8pcS0 = parcelRequire("8pcS0");

var $3JqyB = parcelRequire("3JqyB");
var $2igSQ = parcelRequire("2igSQ");
const $aaaff26cb260a96a$export$fb67b4c81279b22e = (extension)=>{
    if (!extension) return null;
    const { extensionKey: extensionKey, parameters: parameters } = extension;
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).TEMPLATE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3JqyB.TemplateVariableComponent), {
        parameters: parameters
    });
    return null;
};
const $aaaff26cb260a96a$export$14d3630cd94f43d4 = (extension)=>{
    if (!extension) return null;
    const { extensionKey: extensionKey, parameters: parameters } = extension;
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).TEMPLATE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2igSQ.TemplateVariableInput), {
        parameters: parameters
    });
    return null;
};

});
parcelRegister("3JqyB", function(module, exports) {

$parcel$export(module.exports, "TemplateVariableComponent", () => $f366aa2b03faa65b$export$3e35a8e6e9fd352d);

var $gwFzn = parcelRequire("gwFzn");

var $kwjRd = parcelRequire("kwjRd");
const $f366aa2b03faa65b$export$3e35a8e6e9fd352d = ({ parameters: parameters })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kwjRd.TemplateVariableNameWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kwjRd.TemplateVariableName), {
        "data-testid": "variable-name"
    }, parameters?.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kwjRd.TemplateVariableType), {
        "data-testid": "variable-type"
    }, `| ${parameters?.type}`));
};

});


parcelRegister("icKBu", function(module, exports) {

$parcel$export(module.exports, "CreateFromTemplateHandler", () => $f19eca96759725e5$export$30c773822372f598);

var $gwFzn = parcelRequire("gwFzn");

var $fuLIO = parcelRequire("fuLIO");

var $cYJC5 = parcelRequire("cYJC5");
const $f19eca96759725e5$export$30c773822372f598 = ({ hasADF: hasADF, macroDefaultProps: macroDefaultProps, cloudId: cloudId, userId: userId, isPreviewMode: isPreviewMode, shouldLoadAfterPaint: shouldLoadAfterPaint })=>{
    if (!hasADF) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fuLIO.LegacyMacroRendererQuery), macroDefaultProps);
    return shouldLoadAfterPaint || isPreviewMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cYJC5.LazyCreateFromTemplateLoader), {
        userId: userId,
        cloudId: cloudId,
        macroDefaultProps: macroDefaultProps,
        isPreviewMode: isPreviewMode
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cYJC5.CreateFromTemplateLoader), {
        userId: userId,
        cloudId: cloudId,
        macroDefaultProps: macroDefaultProps,
        isPreviewMode: isPreviewMode
    });
};

});

parcelRegister("8YuRm", function(module, exports) {

$parcel$export(module.exports, "LiveSearchHandler", () => $1fa3854e066af442$export$e8ac5007ab7a695a);

var $gwFzn = parcelRequire("gwFzn");

var $fuLIO = parcelRequire("fuLIO");

var $6mEZ3 = parcelRequire("6mEZ3");

var $l7BGZ = parcelRequire("l7BGZ");
const $1fa3854e066af442$export$e8ac5007ab7a695a = ({ hasADF: hasADF, macroDefaultProps: macroDefaultProps, shouldLoadAfterPaint: shouldLoadAfterPaint })=>{
    // Fallback to LegacyMacroRenderer when adf string is not defined
    if (!hasADF) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fuLIO.LegacyMacroRendererQuery), macroDefaultProps);
    const { node: node } = macroDefaultProps;
    const macroNode = (0, $6mEZ3.extensionToADF)(node);
    return shouldLoadAfterPaint ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $l7BGZ.LazyLiveSearchLoader), {
        macroNode: macroNode
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $l7BGZ.LiveSearchLoader), {
        macroNode: macroNode
    });
};

});

parcelRegister("gvBC9", function(module, exports) {

$parcel$export(module.exports, "TableOfContentsHandler", () => $ab0c2ef401baeb08$export$cf1c26fcb7e6ff9f);

var $gwFzn = parcelRequire("gwFzn");

var $fuLIO = parcelRequire("fuLIO");

var $dwS6P = parcelRequire("dwS6P");
const $ab0c2ef401baeb08$export$cf1c26fcb7e6ff9f = ({ adf: adf, macroDefaultProps: macroDefaultProps, cloudId: cloudId, userId: userId, shouldLoadAfterPaint: shouldLoadAfterPaint })=>{
    if (!adf) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fuLIO.LegacyMacroRendererQuery), macroDefaultProps);
    return shouldLoadAfterPaint ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dwS6P.LazyTableOfContentsLoader), {
        userId: userId,
        cloudId: cloudId,
        adf: adf,
        macroDefaultProps: macroDefaultProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dwS6P.TableOfContentsLoader), {
        userId: userId,
        cloudId: cloudId,
        adf: adf,
        macroDefaultProps: macroDefaultProps
    });
};

});

parcelRegister("4W2RN", function(module, exports) {

$parcel$export(module.exports, "MacroReference", () => $3bd71c84d7d120d2$export$c25b654b62d7c7b4);

var $csnse = parcelRequire("csnse");

var $dx8CK = parcelRequire("dx8CK");
const $3bd71c84d7d120d2$var$memoAdfParsed = (0, $csnse.default)((adf)=>{
    let result = adf;
    if (typeof adf === "string") try {
        result = JSON.parse(adf);
    } catch (e) {
        result = {
            version: 1,
            type: 'doc',
            content: []
        };
    }
    return result;
});
const $3bd71c84d7d120d2$export$c25b654b62d7c7b4 = ({ adf: adf, extensionParams: extensionParams, referentialityDataSourceProvider: referentialityDataSourceProvider, children: children })=>{
    const adfParsed = $3bd71c84d7d120d2$var$memoAdfParsed(adf);
    const { references: references } = (0, $dx8CK.useReference)({
        adf: adfParsed,
        extensionParams: extensionParams,
        dataSourceProvider: referentialityDataSourceProvider
    });
    return children({
        references: references
    });
};

});

parcelRegister("7zb5a", function(module, exports) {

$parcel$export(module.exports, "sendTrackingEvent", () => $27d039b331e27185$export$b7595b0733376572);
var $27d039b331e27185$var$Styles = /*#__PURE__*/ function(Styles) {
    Styles["None"] = "none";
    Styles["Mixed"] = "mixed";
    Styles["Bullet"] = "bullet";
    Styles["Circle"] = "circle";
    Styles["Square"] = "square";
    Styles["Number"] = "number";
    return Styles;
}($27d039b331e27185$var$Styles || {});
var $27d039b331e27185$var$Separators = /*#__PURE__*/ function(Separators) {
    Separators["Brackets"] = "brackets";
    Separators["Braces"] = "braces";
    Separators["Pipe"] = "pipe";
    return Separators;
}($27d039b331e27185$var$Separators || {});
const $27d039b331e27185$export$b7595b0733376572 = (macroName, trackingData, createAnalyticsEvent, contentId)=>{
    const { minLevel: minLevel, maxLevel: maxLevel, outline: outline, type: type, printable: printable, style: style, separator: separator, include: include, exclude: exclude, indent: indent } = trackingData;
    const sensitiveData = {
        include: include?.value.length > 0 || false,
        exclude: exclude?.value.length > 0 || false,
        class: trackingData.class?.value.length > 0 || false,
        indent: indent?.value.length > 0 || false
    };
    // in the unlikely event these dropdown fields become custom input text, ensure no PII is logged
    const separatorValue = Object.values($27d039b331e27185$var$Separators).includes(separator?.value) ? separator?.value : 'invalid';
    const styleValue = Object.values($27d039b331e27185$var$Styles).includes(style?.value) ? style?.value : 'invalid';
    const potentiallySensitiveData = {};
    if (type) {
        if (type.value === 'flat') potentiallySensitiveData['separator'] = separatorValue;
        else if (type.value === 'list') potentiallySensitiveData['style'] = styleValue;
    } else potentiallySensitiveData['style'] = 'mixed';
    const nonSensitiveData = {
        minLevel: parseInt(minLevel?.value) || 1,
        maxLevel: parseInt(maxLevel?.value) || 6,
        outline: outline?.value === 'true' || false,
        printable: printable?.value === 'false' || true,
        type: type?.value === "flat" ? "flat" : "list"
    };
    createAnalyticsEvent({
        type: "sendTrackEvent",
        data: {
            action: "viewed",
            actionSubject: "macro",
            actionSubjectId: macroName,
            source: "on page view",
            attributes: {
                pageID: contentId,
                ...sensitiveData,
                ...potentiallySensitiveData,
                ...nonSensitiveData
            },
            eventType: "track"
        }
    }).fire();
};

});


parcelRegister("69aHU", function(module, exports) {

$parcel$export(module.exports, "populateExtensionProviders", () => $2d9ea9a54c5e94d8$export$c0ba9eb7d0e2ed47);

var $eEmxu = parcelRequire("eEmxu");
var $bre0g = parcelRequire("bre0g");

var $5bak6 = parcelRequire("5bak6");

var $gKr8t = parcelRequire("gKr8t");

var $bfil7 = parcelRequire("bfil7");

var $8pcS0 = parcelRequire("8pcS0");

var $04e9M = parcelRequire("04e9M");

var $aIqlA = parcelRequire("aIqlA");

var $8z3oB = parcelRequire("8z3oB");
var $aF5bm = parcelRequire("aF5bm");

var $9wGTI = parcelRequire("9wGTI");

var $gxXVf = parcelRequire("gxXVf");

var $6y6Gt = parcelRequire("6y6Gt");

var $bgcaM = parcelRequire("bgcaM");

const $2d9ea9a54c5e94d8$var$createLCMRendererExtensionProvider = async ()=>{
    const { rendererManifest: rendererManifest } = await (parcelRequire("krPyM"));
    return new (0, $bre0g.default)([
        rendererManifest
    ]);
};
const $2d9ea9a54c5e94d8$export$c0ba9eb7d0e2ed47 = (providerFactory, { intl: intl, containerId: containerId, accountId: accountId, cloudId: cloudId, spaceKey: spaceKey, spaceId: spaceId, contentId: contentId, contentType: contentType, environment: environment, extensionHandlers: extensionHandlers, showTemplateInputInPreview: showTemplateInputInPreview, showTemplateVariablesInPreview: showTemplateVariablesInPreview, setManifestReadyState: setManifestReadyState, createAnalyticsEvent: createAnalyticsEvent, activationId: activationId, isLivePage: isLivePage = false, isLivePagesFeatureEnabled: isLivePagesFeatureEnabled = false })=>{
    const extensionProvidersList = [];
    const extensionProvider = (0, $bfil7.getConfluenceMacrosExtensionProviderForRenderer)({
        contentId: contentId,
        spaceKey: spaceKey,
        spaceId: spaceId,
        features: {}
    }, extensionHandlers, (0, $bgcaM.getMigrationExtensionManifest), (0, $gxXVf.openMacroBrowserToEditExistingMacro), (0, $gxXVf.openMacroBrowserForInitialConfiguration), intl, createAnalyticsEvent, providerFactory, isLivePagesFeatureEnabled);
    extensionProvidersList.push(extensionProvider);
    const lcmExtension = $2d9ea9a54c5e94d8$var$createLCMRendererExtensionProvider();
    extensionProvidersList.push(lcmExtension);
    if (showTemplateInputInPreview || showTemplateVariablesInPreview) extensionProvidersList.push(new (0, $bre0g.default)([
        (0, $6y6Gt.getTemplateVariableExtensionManifest)(intl, showTemplateInputInPreview ? (0, $6y6Gt.TemplateVariableMode).INPUT : (0, $6y6Gt.TemplateVariableMode).CONFIG)
    ]));
    const apolloClient = (0, $gKr8t.getAGGClient)();
    const contextIds = [
        (0, $aF5bm.getWorkspaceARI)({
            cloudId: cloudId,
            activationId: activationId
        })
    ];
    const forgeExtensionProvider = async ()=>{
        const getProviderOptions = ({ spaceKey: spaceKeyArg })=>({
                accountId: accountId ?? undefined,
                cloudId: cloudId,
                apolloClient: apolloClient,
                contextIds: contextIds,
                dataProviders: providerFactory,
                environment: (0, $5bak6.environmentToForgeProductEnvironment)(environment),
                product: 'confluence',
                page: 'confluence:macroRenderer',
                isEditing: false,
                analyticsWebClient: (0, $04e9M.getAnalyticsWebClient)(),
                forgeUIAnalyticsContext: (0, $5bak6.createForgeUIAnalyticsContext)({
                    objectId: contentId,
                    // @ts-ignore
                    objectType: contentType,
                    containerId: containerId,
                    containerType: 'space'
                }),
                extensionData: (0, $5bak6.createForgeMacroExtensionData)({
                    spaceKey: spaceKeyArg ?? '',
                    isLivePage: isLivePage,
                    spaceId: spaceId ?? '',
                    contentId: contentId,
                    contentType: contentType
                }),
                extensionHandlerWithReference: extensionHandlers[(0, $8pcS0.EXTENSION_TYPE).MACRO_WITH_REFERENCES],
                connectExtensionProvider: extensionProvider,
                FlagProvider: $8z3oB.FlagProvider,
                extensionsFilter: undefined,
                locale: intl.locale
            });
        return (0, $aIqlA.fetchForgeExtensionProvider)({
            getProviderOptions: getProviderOptions,
            spaceKey: spaceKey
        });
    };
    extensionProvidersList.push(forgeExtensionProvider());
    if ((0, $9wGTI.fg)('confluence_preload_extension_providers')) {
        const combinedProvider = (0, $eEmxu.default)(extensionProvidersList);
        providerFactory.setProvider('extensionProvider', Promise.resolve(combinedProvider));
        // Call preload on all provider that later we can use it synchronously in packages/editor/editor-common/src/extensions/extension-handlers.tsx
        combinedProvider?.preload?.().then(()=>{
            setManifestReadyState?.(true);
        });
    } else {
        if (extensionProvidersList.length > 0) providerFactory.setProvider('extensionProvider', Promise.resolve((0, $eEmxu.default)(extensionProvidersList)));
        // Make sure we set mainfestReadyState always
        Promise.all(extensionProvidersList).then(()=>{
            setManifestReadyState?.(true);
        });
    }
};

});
parcelRegister("6y6Gt", function(module, exports) {

$parcel$export(module.exports, "TemplateVariableMode", () => $399836d35d211a20$export$f73f87f0b8cabb66);
$parcel$export(module.exports, "getTemplateVariableExtensionManifest", () => $399836d35d211a20$export$de09af8432d39de0);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");

var $eIlE7 = parcelRequire("eIlE7");

var $3JqyB = parcelRequire("3JqyB");
var $2igSQ = parcelRequire("2igSQ");

var $8pcS0 = parcelRequire("8pcS0");

var $2oer2 = parcelRequire("2oer2");
var $399836d35d211a20$export$f73f87f0b8cabb66 = /*#__PURE__*/ function(TemplateVariableMode) {
    TemplateVariableMode[TemplateVariableMode["CONFIG"] = 0] = "CONFIG";
    TemplateVariableMode[TemplateVariableMode["INPUT"] = 1] = "INPUT";
    return TemplateVariableMode;
}({});
const $399836d35d211a20$var$i18n = (0, $2nPZH.defineMessages)({
    templateVariablesAdd: {
        id: "confluence-fabric-editor.template.variables.add",
        defaultMessage: "New variable"
    },
    templateVariablesAddTooltip: {
        id: "confluence-fabric-editor.template.variables.add.tooltip",
        defaultMessage: "Add a new field into the page for the template user to fill out."
    }
});
function $399836d35d211a20$export$de09af8432d39de0(intl, mode = 0, config, editorActions) {
    const type = 'inlineExtension';
    const title = intl.formatMessage($399836d35d211a20$var$i18n.templateVariablesAdd);
    const Component = mode === 1 ? (0, $2igSQ.TemplateVariableInput) : (0, $3JqyB.TemplateVariableComponent);
    return {
        key: (0, $8pcS0.EXTENSION_KEY).TEMPLATE,
        type: (0, $8pcS0.EXTENSION_TYPE).TEMPLATE,
        title: title,
        description: intl.formatMessage($399836d35d211a20$var$i18n.templateVariablesAddTooltip),
        icons: {
            '48': async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eIlE7))), {
                        color: "currentColor",
                        label: title,
                        spacing: "spacious"
                    })
        },
        modules: {
            quickInsert: editorActions && [
                {
                    key: (0, $8pcS0.EXTENSION_KEY).TEMPLATE,
                    featured: true,
                    action: {
                        type: 'node',
                        key: 'default',
                        parameters: {
                            type: (0, $2oer2.TEXT_TYPE),
                            name: (0, $2oer2.defaultVariableName)
                        }
                    }
                }
            ],
            nodes: {
                default: {
                    type: type,
                    render: async ()=>({ node: node })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Component, {
                                parameters: node.parameters
                            }),
                    update: config && (async (parameters)=>{
                        try {
                            const { attrs: attrs } = await (0, $2oer2.openTemplateVariableDialog)({
                                type: type,
                                attrs: {
                                    parameters: parameters
                                }
                            }, config);
                            return attrs.parameters || parameters;
                        } catch  {
                            // On error keep the existing value
                            return parameters;
                        }
                    })
                }
            }
        }
    };
}

});
parcelRegister("2oer2", function(module, exports) {

$parcel$export(module.exports, "TEXT_TYPE", () => $653189039caa12b3$export$ae3b897442224943);
$parcel$export(module.exports, "defaultVariableName", () => $653189039caa12b3$export$178c63c1bbc65458);
$parcel$export(module.exports, "openTemplateVariableDialog", () => $653189039caa12b3$export$9d5f42c8c61fd9fc);

var $iol5P = parcelRequire("iol5P");

var $j2dS3 = parcelRequire("j2dS3");

var $8pcS0 = parcelRequire("8pcS0");

var $cbr0D = parcelRequire("cbr0D");
const $653189039caa12b3$export$ae3b897442224943 = "text";
const $653189039caa12b3$export$a43e313f04be91d7 = "textarea";
const $653189039caa12b3$export$22c50a44ec8aa5dd = "select";
const $653189039caa12b3$export$178c63c1bbc65458 = "variable_name";
function $653189039caa12b3$export$166100f9abd52166(name = $653189039caa12b3$export$178c63c1bbc65458) {
    return {
        type: (0, $8pcS0.INLINE_EXTENSION_TYPE),
        attrs: {
            extensionType: (0, $8pcS0.EXTENSION_TYPE).TEMPLATE,
            extensionKey: (0, $8pcS0.EXTENSION_KEY).TEMPLATE,
            parameters: {
                type: $653189039caa12b3$export$ae3b897442224943,
                name: name
            }
        }
    };
}
function $653189039caa12b3$export$fd5152d3cbf54f5f(node) {
    return node.attrs && node.attrs.extensionType === (0, $8pcS0.EXTENSION_TYPE).TEMPLATE;
}
function $653189039caa12b3$export$9d5f42c8c61fd9fc(selectedNode, config) {
    return new Promise((resolve, reject)=>{
        if (!selectedNode.attrs || !config.setActiveModal) {
            reject(new Error("Cannot open editing template variable dialog"));
            return;
        }
        const params = selectedNode.attrs.parameters;
        config.setActiveModal((0, $iol5P.TemplateVariableDialogLoader), {
            defaultVariableType: params.type,
            defaultVariableName: params.name,
            defaultRows: params.params && params.params.rows,
            defaultColumns: params.params && params.params.columns,
            defaultListOptions: params.params && params.params.options,
            onSave: (updatedParams)=>{
                const adf = (0, $j2dS3.updateParams)(selectedNode, updatedParams);
                // MacroAttributes and ADNode are pretty much the same type, but
                // MacroAttributes requires either "extension", "bodiedExtension", or
                // "inlineExtension". This check is so we can pass the ADNode as a
                // MacroAttributes, but will default to "extension" if given an
                // unexpected value.
                let extensionType = (0, $8pcS0.REGULAR_EXTENSION_TYPE);
                if (adf.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) extensionType = (0, $8pcS0.BODIED_EXTENSION_TYPE);
                else if (adf.type === (0, $8pcS0.INLINE_EXTENSION_TYPE)) extensionType = (0, $8pcS0.INLINE_EXTENSION_TYPE);
                resolve({
                    ...adf,
                    type: extensionType,
                    attrs: adf.attrs || {}
                });
            },
            onClose: ()=>{
                if (config.closeActiveModal) config.closeActiveModal();
            }
        });
    });
}

});
parcelRegister("iol5P", function(module, exports) {

$parcel$export(module.exports, "TemplateVariableDialogLoader", () => $2957f690f8f5a888$export$4072164b6bd9337);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $lOkIA = parcelRequire("lOkIA");

const $2957f690f8f5a888$export$4072164b6bd9337 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "FUMAJ",
    name: "TemplateVariableDialogLoader",
    loader: async ()=>(await (parcelRequire("d5SJI"))).TemplateVariableDialogComponent,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium"
        })
});

});
parcelRegister("d5SJI", function(module, exports) {

let $988633801f46cd7a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $988633801f46cd7a$var$load("6IjKj").then(()=>parcelRequire('5KoaE'));

});


parcelRegister("j2dS3", function(module, exports) {

$parcel$export(module.exports, "updateParams", () => $a9c66c4a525522c3$export$8198c5b4e81b9082);
$parcel$export(module.exports, "filterADNodesByType", () => $a9c66c4a525522c3$export$676214b4858262c1);
function $a9c66c4a525522c3$export$e2b5c5db9e2009fd(node) {
    return node.type.name || node.type;
}
function $a9c66c4a525522c3$export$8198c5b4e81b9082(node, newParams) {
    return {
        type: $a9c66c4a525522c3$export$e2b5c5db9e2009fd(node),
        attrs: {
            ...node.attrs,
            parameters: {
                ...node.attrs.parameters,
                ...newParams
            }
        }
    };
}
function $a9c66c4a525522c3$export$d1c50812de760a07(root, callbackFunc) {
    for (const nodeKey of Object.keys(root)){
        const nodeValue = root[nodeKey];
        callbackFunc(nodeKey, nodeValue);
        // go deeper
        if (nodeValue !== null && typeof nodeValue === "object") $a9c66c4a525522c3$export$d1c50812de760a07(root[nodeKey], callbackFunc);
    }
}
function $a9c66c4a525522c3$export$676214b4858262c1(root, typeName) {
    const results = [];
    $a9c66c4a525522c3$export$d1c50812de760a07(root, (_nodeKey, nodeValue)=>{
        if (nodeValue && nodeValue.type === typeName) results.push(nodeValue);
    });
    return results;
}

});



parcelRegister("bgcaM", function(module, exports) {

$parcel$export(module.exports, "getMigrationExtensionManifest", () => $bc16cbc3cc94b402$export$fb67662ebef720ab);

var $gwFzn = parcelRequire("gwFzn");

var $jdPfT = parcelRequire("jdPfT");

var $8pcS0 = parcelRequire("8pcS0");

var $5h7sn = parcelRequire("5h7sn");
var $bQCqI = parcelRequire("bQCqI");
var $cpwiw = parcelRequire("cpwiw");

var $k6bGh = parcelRequire("k6bGh");
function $bc16cbc3cc94b402$export$fb67662ebef720ab(contentId, isEditor, flags, createAnalyticsEvent) {
    const type = 'inlineExtension';
    const getExtensionHandler = isEditor ? (0, $5h7sn.getMigrationExtHandlerForEditor) : (0, $bQCqI.getMigrationExtHandlerForRenderer);
    return [
        (0, $8pcS0.EXTENSION_KEY).INVALID,
        (0, $8pcS0.EXTENSION_KEY).INLINE_MEDIA_IMAGE,
        (0, $8pcS0.EXTENSION_KEY).INLINE_EXTERNAL_IMAGE
    ].map((key)=>({
            title: 'Migration Extension',
            key: key,
            type: (0, $8pcS0.EXTENSION_TYPE).MIGRATION,
            icons: {
                '48': async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                            label: "Migration Extension"
                        })
            },
            modules: {
                nodes: {
                    default: {
                        type: type,
                        render: async ()=>({ node: node })=>getExtensionHandler({
                                    contentId: contentId,
                                    contextProviders: {
                                        ClassicEditorContextProvider: (0, $k6bGh.ClassicEditorContextProviderLazyLoader)
                                    }
                                })(node, {}),
                        update: isEditor ? (parameters)=>(0, $cpwiw.showUnmodifiableMacroFlag)({
                                type: type,
                                attrs: {
                                    parameters: parameters
                                }
                            }, flags, createAnalyticsEvent) : undefined
                    }
                }
            }
        }));
}

});
parcelRegister("cpwiw", function(module, exports) {

$parcel$export(module.exports, "showUnmodifiableMacroFlag", () => $3d419e1dae817d20$export$752d3018048f7d27);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $8am3c = parcelRequire("8am3c");
const $3d419e1dae817d20$var$i18n = (0, $2nPZH.defineMessages)({
    unmodifiableMacroDialogTitle: {
        id: "fabric-extension-handlers.unmodifiable.macro.dialog.title",
        defaultMessage: "This macro can\u2019t be edited"
    },
    unmodifiableMacroDialogBody: {
        id: "fabric-extension-handlers.unmodifiable.macro.dialog.body",
        defaultMessage: "This macro was added to a page that was converted from the legacy editor. It can\u2019t be edited because it is now incompatible with the <alink>current editor</alink>."
    }
});
const $3d419e1dae817d20$export$752d3018048f7d27 = (selectedNode, flags, createAnalyticsEvent)=>new Promise((resolve, reject)=>{
        if (!selectedNode || !selectedNode.attrs || !flags) {
            reject(new Error('Cannot show unmodifiable macro error flag'));
            return;
        }
        const fireLinkClickAnalytics = ()=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'link',
                    actionSubjectId: 'unmodifiableMacroDialogComponentLearnMoreLink',
                    source: 'showUnmodifiableMacroFlag'
                }
            }).fire();
        };
        flags.showFlag({
            type: 'error',
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $3d419e1dae817d20$var$i18n.unmodifiableMacroDialogTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
                ...$3d419e1dae817d20$var$i18n.unmodifiableMacroDialogBody,
                values: {
                    alink: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
                            href: (0, $8am3c.LEARN_MORE_URL),
                            target: "_blank",
                            onClick: fireLinkClickAnalytics
                        }, chunks)
                }
            }),
            close: 'auto'
        });
        resolve();
    });

});
parcelRegister("8am3c", function(module, exports) {

$parcel$export(module.exports, "PLUGIN_KEY", () => $5f205cb1fe7d8e74$export$2dd355223baa0569);
$parcel$export(module.exports, "PAGE_MIGRATION_FEATURE_KEY", () => $5f205cb1fe7d8e74$export$73d3e00099fbbdb2);
$parcel$export(module.exports, "LEARN_MORE_URL", () => $5f205cb1fe7d8e74$export$af6d68522cb370b8);
const $5f205cb1fe7d8e74$export$2dd355223baa0569 = 'com.atlassian.confluence.plugins.confluence-frontend-support';
const $5f205cb1fe7d8e74$export$73d3e00099fbbdb2 = 'confluence.fabric.page.migration.banner';
const $5f205cb1fe7d8e74$export$af6d68522cb370b8 = 'https://confluence.atlassian.com/confcloud/converting-pages-to-the-new-editor-993930226.html';

});



parcelRegister("krPyM", function(module, exports) {

let $ee2e52fe217d7ad5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ee2e52fe217d7ad5$var$load("iq6Zv").then(()=>parcelRequire('8pP5E'));

});


var $fb06574350f1eb12$exports = {};

(parcelRequire("fzRTW")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"cRUrz\",\"ClassicEditorContextProvider.7b0c1abe.js\",\"2wLue\",\"confluence-macro-browser-overrides.820078d1.js\",\"fZNCx\",\"ClassicEditorContextProvider.bed3e298.js\",\"kJ4C4\",\"js.70ff2b00.js\",\"k7UyM\",\"png-chunks-extract.5f6af93f.js\",\"6KGrg\",\"EmojiComponent.c28efb26.js\",\"KsAVd\",\"GlobalFeedbackCollector.91cada8b.js\",\"4aLlP\",\"cross-circle.5619900c.js\",\"6ZETc\",\"smart-link.587c04b9.js\",\"1lvsb\",\"EmojiTitlePopover.92660a1d.js\",\"9Zd2C\",\"EmojiTitleButton.91c16c21.js\",\"dGk3x\",\"GlobalFeedbackCollector.8473f672.js\",\"cyGuT\",\"feedback-collector.414f737a.js\",\"aZinD\",\"vendors.17bc1977.js\",\"c6MKV\",\"stable_vendors.3bd64941.js\",\"aZinD\",\"vendors.17bc1977.js\",\"c6MKV\",\"stable_vendors.3bd64941.js\",\"hrAMe\",\"GlobalFeedbackCollector.ae60fda5.js\",\"87F9B\",\"GlobalFeedbackCollector.99f46344.js\",\"8Khwy\",\"GlobalFeedbackCollector.7c1b47d5.js\",\"hTb35\",\"GlobalFeedbackCollector.34cdb949.js\",\"fZyYv\",\"pubsub.abb58368.js\",\"XgRtr\",\"EmojiPicker.aacfff3e.js\",\"hUMW4\",\"render.92951296.js\",\"1RolH\",\"EmojiPickerComponent.561dea18.js\",\"1sEV4\",\"objects.828d82d3.js\",\"cUIjD\",\"frequent.efd5f917.js\",\"3xznI\",\"search.0780a38a.js\",\"6j8nK\",\"symbols.1a8ae208.js\",\"6Tafs\",\"people.dbf024a3.js\",\"etwBB\",\"activity.d3402161.js\",\"a2rZD\",\"custom.b28554c7.js\",\"4yJnq\",\"add.c7dd6669.js\",\"ePm95\",\"flags.40431f78.js\",\"kJcWg\",\"food.473b199a.js\",\"4tIwu\",\"nature.96f73db7.js\",\"i1sL7\",\"travel.5460db1e.js\",\"36ctu\",\"productivity.d04fd7d4.js\",\"4hZJd\",\"EmojiTitleSelection.b9f5507b.js\",\"hUvv7\",\"LiveDocsDefaultIcon.d44543de.js\",\"5joXW\",\"GuestRequestToUpgradeToUser.7da96066.js\",\"1epse\",\"GuestRequestToUpgradeLearnMoreModal.c84e10ee.js\",\"8Txex\",\"Guest-Avatar.ebdf69f1.svg\",\"2wyTK\",\"Team-Avatars.4f1b07ad.svg\",\"3wN5D\",\"ExternalSpaceLozenge.38f5d055.js\",\"j3iEF\",\"CommentAddPromptNudgeText.e6594543.js\",\"lwUFR\",\"RequestAccessForUnassignedGuest.9a35b3a7.js\",\"aad5M\",\"Collaboration-Bike.8735a1c6.svg\",\"7Ni3R\",\"GuestOnboardingModal.3f76c08f.js\",\"WYAWv\",\"Guest-Onboarding-Light.8e788fbd.svg\",\"4rpM2\",\"Guest-Onboarding-Dark.f055cab3.svg\",\"9mi9f\",\"BannerSpacer.581de0f1.js\",\"2pYvv\",\"LinkCardsExtension.15b6f854.js\",\"i4cia\",\"component-lazy.1bcbc7bc.js\",\"cMkgU\",\"16.51bd8726.js\",\"kDqHr\",\"file-icon.33dd8f9f.js\",\"icyPI\",\"document-filled.4b826be1.js\",\"4HZlX\",\"chart-bar-icon.3a62bad3.js\",\"7jSfd\",\"list-bullet-icon.78de678b.js\",\"4x0L6\",\"people-group.e7ed4330.js\",\"bZO0a\",\"people-group.b7831300.js\",\"k6H7B\",\"file--document-filled.9932b544.js\",\"7OtNC\",\"16.25d5434d.js\",\"dzfxi\",\"16.77d0f410.js\",\"47wm8\",\"16.ae36793b.js\",\"f28kH\",\"16.87120fc0.js\",\"j2OLf\",\"16.20dd34be.js\",\"fKONs\",\"16.85a9fe8d.js\",\"3c6qD\",\"16.fb87f4ed.js\",\"b1gz4\",\"16.f54526f0.js\",\"8Xuep\",\"16.4f6e423d.js\",\"abVVB\",\"16.a2ebd64f.js\",\"l42ar\",\"16.e4f5974c.js\",\"hlqS1\",\"16.9935b550.js\",\"bzjLG\",\"component-lazy.06cc2be2.js\",\"15APZ\",\"modal.b481cca9.js\",\"kDLrp\",\"EmbedModal.bd8789d7.js\",\"dUKeO\",\"vid-full-screen-on.89bfbdcb.js\",\"iiqDR\",\"vid-full-screen-off.edfa2cde.js\",\"i8IR3\",\"lock.20202240.js\",\"9Rd6U\",\"modal.7c6a0d12.js\",\"kO0mz\",\"audio-icon.65c3da31.js\",\"jDjSj\",\"16.8a4cce0e.js\",\"gQLjx\",\"angle-brackets-icon.d63c6415.js\",\"3wmvj\",\"16.b741d755.js\",\"5i5pX\",\"folder-icon.3e3b36ad.js\",\"eA5B3\",\"image-icon.b775263b.js\",\"8059b\",\"16.afe6487f.js\",\"7AsyI\",\"video-icon.a517ba32.js\",\"hPalR\",\"16.93dce164.js\",\"8LPnw\",\"lock-locked--lock-filled.311149cb.js\",\"2fk6g\",\"16.bea78523.js\",\"dil5i\",\"24.e2acaae5.js\",\"huUvS\",\"16.ec1fe873.js\",\"P5iE2\",\"24.18a80ac0.js\",\"1oiJ6\",\"16.b49b338d.js\",\"42vdC\",\"24.4866b870.js\",\"lxiFd\",\"16.80951c67.js\",\"9Bu2S\",\"24.7e9eed6c.js\",\"eDqo1\",\"16.f4617b7e.js\",\"8pE8S\",\"24.1dfa6a18.js\",\"6HBYC\",\"16.64a21052.js\",\"ivQYH\",\"24.60e86884.js\",\"bYxCZ\",\"16.aa8224a8.js\",\"7a9CL\",\"24.65a207a0.js\",\"eTBsW\",\"16.fd6383aa.js\",\"8mzoy\",\"24.5f907e8d.js\",\"020xd\",\"16.f33a251e.js\",\"bjzRn\",\"24.44a1e682.js\",\"ls0Um\",\"16.0d741008.js\",\"fYi1a\",\"24.985662b4.js\",\"eVYW1\",\"16.fd806601.js\",\"fqrMn\",\"24.60e4661d.js\",\"f35QR\",\"16.b6568c92.js\",\"hzK1f\",\"24.cd837e44.js\",\"4sSyn\",\"24.aa38ac65.js\",\"dnrR3\",\"24.96022979.js\",\"gxkp2\",\"24.c8cd3e14.js\",\"hiqrg\",\"24.09472e1b.js\",\"490Jr\",\"24.149eb8b7.js\",\"ggkqU\",\"24.890d556e.js\",\"65smn\",\"24.580531d4.js\",\"1fh7t\",\"24.fa918456.js\",\"4mLGd\",\"24.682f9297.js\",\"cMlHc\",\"24.a7d92bbc.js\",\"lSzlP\",\"24.5451f6fa.js\",\"5erPe\",\"24.4641fb84.js\",\"cXodu\",\"24.78cf490b.js\",\"3vYMs\",\"attachment.7777c63a.js\",\"8PsNg\",\"attachment.cc4e334e.js\",\"9UmxH\",\"task.44180bef.js\",\"d1W0Z\",\"task.bbe0897b.js\",\"hlgZa\",\"component.7f613fb8.js\",\"aQnhg\",\"component.a0c10401.js\",\"acQiP\",\"comment.8a140e14.js\",\"jSJrn\",\"eye-open--watch.54d1d960.js\",\"jaTPo\",\"watch.5c4b5bd8.js\",\"kgJcP\",\"thumbs-up--like.0d91b8c9.js\",\"dkV2T\",\"like.d696faec.js\",\"513ba\",\"arrow-up.119f7954.js\",\"9f4oR\",\"arrow-up.94369a38.js\",\"kefuj\",\"priority-blocker.d8096123.js\",\"bWqqo\",\"priority-critical.c242bf7a.js\",\"9ZeC1\",\"priority-high.3eb9ac43.js\",\"9zpNb\",\"priority-highest.0e78632a.js\",\"gOpe6\",\"priority-low.21ac1cc4.js\",\"RAL03\",\"priority-lowest.535dc7b3.js\",\"5nQIT\",\"priority-major.94eb9450.js\",\"l9frT\",\"priority-medium.3a2d978a.js\",\"lACXG\",\"priority-minor.d2ac136e.js\",\"ao5oO\",\"priority-trivial.965f2280.js\",\"7owaE\",\"question-circle--question.0e0d9e54.js\",\"9PQvE\",\"angle-brackets--code.229a6e25.js\",\"9DPul\",\"code.657e8fdd.js\",\"9FBaW\",\"people-group--people.4f9487ba.js\",\"9dfxa\",\"subtasks--subtask.85d82f30.js\",\"hl2oi\",\"subtask.f317d926.js\",\"3wY4G\",\"goal-icon.c8c90c26.js\",\"88r9N\",\"projects-icon.c26711c5.js\",\"cqZpg\",\"manual-triggers-modal.98d1ca56.js\",\"aoU9B\",\"RelatedLinksModal.f79afe76.js\",\"dTsOE\",\"modal.0d95ebdf.js\",\"kUAIU\",\"more.9db3674e.js\",\"4lfDj\",\"edit.b59079ec.js\",\"3ooAX\",\"download.4d27b891.js\",\"9QvHa\",\"actual-size.810640aa.js\",\"2w2Fa\",\"child-issues.1773a591.js\",\"18vkH\",\"modal.bfda36ab.js\",\"2gYco\",\"LinkCards.5d103678.js\",\"iuVYg\",\"RestrictedContent.b8a54c0d.svg\",\"kQxM6\",\"NoResults.9d75157a.svg\",\"3NiBX\",\"LinkCards.887e1d9d.js\",\"iOWBI\",\"LinkCards.cfdd6d66.js\",\"8dyWu\",\"CardMacroIcon.550a1caf.js\",\"8CeYz\",\"Renderer.b56c4164.js\",\"jHYIB\",\"segment-highlight.9f59281f.js\",\"bCr24\",\"main.11d7a55f.js\",\"lp0cK\",\"both-splash.465c87c4.svg\",\"bo7LK\",\"teams-splash.36cc0781.svg\",\"8XHrw\",\"slack-splash.73e116f6.svg\",\"6Yu8N\",\"main.dc89804b.js\",\"6zfzy\",\"modal.2203b291.js\",\"a4Sf9\",\"main.f411aea3.js\",\"cqNU4\",\"CommentWarningDialog.8ab29726.js\",\"1C6qR\",\"Reactions.d328d460.js\",\"2PEGr\",\"monitoring.49c9dd3b.js\",\"2AZMe\",\"render.290f6230.js\",\"2YtxS\",\"more.f1abb0de.js\",\"aYGIV\",\"emoji-add.d74ae556.js\",\"8Ovry\",\"CommentEditor.e5ee1256.js\",\"eSDS8\",\"modal.44531bd9.js\",\"bEo2Z\",\"standard.6c3cc6ed.svg\",\"bRtcL\",\"modal.73b4407d.js\",\"7fMGd\",\"dark.16cc06e7.svg\",\"8OP1c\",\"light.e350f7db.svg\",\"gywm1\",\"dark.981334ac.svg\",\"29by2\",\"light.d61b1f64.svg\",\"XXMwE\",\"dark.90199792.svg\",\"cqbvn\",\"light.5ffcf568.svg\",\"6StWh\",\"modal.ea9cec89.js\",\"64Goy\",\"modal.863c77b1.js\",\"k1740\",\"board.e21ca1d1.js\",\"2jsRt\",\"checkbox.4953cee4.js\",\"aQp8v\",\"radio.24323b5b.js\",\"gOlh9\",\"chevron-up.044d5e4d.js\",\"2S1L6\",\"modal.c2336a1a.js\",\"4fCJZ\",\"modal.0e7fc71d.js\",\"1hjmQ\",\"modal.8b15e518.js\",\"gavZG\",\"modal.831468b8.js\",\"40QiO\",\"modal.3cfca588.js\",\"hdsgK\",\"modal.c77b4eef.js\",\"cSv6l\",\"dark.725705dc.svg\",\"hCwKF\",\"light.bf58aa10.svg\",\"4we3T\",\"modal.4e80cb1d.js\",\"7X74w\",\"modal.c7805876.js\",\"2Aekd\",\"modal.4c16300a.js\",\"3wTTx\",\"ParseTreePatternMatcher.9c6b04b0.js\",\"eWzXf\",\"question.2ebb5e70.js\",\"aiceI\",\"fit-to-page.f0e33e59.js\",\"gzdCt\",\"modal.c497299f.js\",\"759Sn\",\"modal.21edc40a.js\",\"hDCAz\",\"panel.0c600537.js\",\"7Vmxp\",\"table.2be41226.js\",\"koKgZ\",\"datasourceRenderFailedAnalyticsWrapper.9fbf001d.js\",\"7ixUU\",\"datasourceTableView.bb58097d.js\",\"91C8u\",\"refresh.8e489499.js\",\"fwuXj\",\"cardWithMediaClient.e332db16.js\",\"cKkZK\",\"media-viewer-error-boundary.dd0174cb.js\",\"bHwQq\",\"archive.38f3ffbf.js\",\"9vSeI\",\"audio.7b721c3b.js\",\"5Pe24\",\"archive.a3e04182.js\",\"e53Dv\",\"vid-play.9e8ddef6.js\",\"5rLJa\",\"vid-pause.69823d28.js\",\"6dDCB\",\"outgoing-sound.2de86a1c.js\",\"8PuzS\",\"archive.29f79635.js\",\"lixGB\",\"78-EUC-H.51d0c3f9.js\",\"fH2pk\",\"78-EUC-V.64ff1cfd.js\",\"kZB45\",\"78-H.0ed13b16.js\",\"6BxSI\",\"78-RKSJ-H.dc86b34e.js\",\"i9zPw\",\"78-RKSJ-V.82830549.js\",\"8Qq8X\",\"78-V.b650b3b6.js\",\"hUHQJ\",\"78ms-RKSJ-H.8d99de38.js\",\"4Y4SR\",\"78ms-RKSJ-V.d9f17393.js\",\"axQaS\",\"83pv-RKSJ-H.f8767ab6.js\",\"hh6Ks\",\"90ms-RKSJ-H.d832d6a6.js\",\"gyPUO\",\"90ms-RKSJ-V.260dbffb.js\",\"aduQJ\",\"90msp-RKSJ-H.364f2808.js\",\"3iFld\",\"90msp-RKSJ-V.aa85de80.js\",\"6XUCn\",\"90pv-RKSJ-H.848d9bac.js\",\"8eJG6\",\"90pv-RKSJ-V.92513b15.js\",\"iveJ5\",\"Add-H.729159c7.js\",\"kOqxj\",\"Add-RKSJ-H.2baf4c23.js\",\"1zYOj\",\"Add-RKSJ-V.24c188d0.js\",\"2MU2T\",\"Add-V.f276585e.js\",\"oH9eX\",\"Adobe-CNS1-0.c94fb46d.js\",\"fSa6m\",\"Adobe-CNS1-1.22c8a053.js\",\"g2oEO\",\"Adobe-CNS1-2.b6e41c65.js\",\"8WzHR\",\"Adobe-CNS1-3.6168987e.js\",\"ca0bh\",\"Adobe-CNS1-4.44238a8c.js\",\"cfcpu\",\"Adobe-CNS1-5.62d26997.js\",\"li5lK\",\"Adobe-CNS1-6.7ebee211.js\",\"kujwR\",\"Adobe-CNS1-UCS2.0dd5c8ce.js\",\"8iFzj\",\"Adobe-GB1-0.249f5de6.js\",\"6D5co\",\"Adobe-GB1-1.74dabbbf.js\",\"cfFSd\",\"Adobe-GB1-2.4a68d0c8.js\",\"exff1\",\"Adobe-GB1-3.b5b05f5d.js\",\"aeuVs\",\"Adobe-GB1-4.c9dd9584.js\",\"aLrjO\",\"Adobe-GB1-5.0e92a2eb.js\",\"j3PYN\",\"Adobe-GB1-UCS2.bb70ebea.js\",\"d0uYO\",\"Adobe-Japan1-0.4d890a6e.js\",\"eEcvV\",\"Adobe-Japan1-1.a0781bed.js\",\"820v9\",\"Adobe-Japan1-2.9f2dc797.js\",\"frVgA\",\"Adobe-Japan1-3.15951cff.js\",\"jdQzX\",\"Adobe-Japan1-4.0cfae895.js\",\"Z8yoS\",\"Adobe-Japan1-5.66dd1b5b.js\",\"k2vqy\",\"Adobe-Japan1-6.7e06fceb.js\",\"kgt4y\",\"Adobe-Japan1-UCS2.e121ba74.js\",\"eP0RM\",\"Adobe-Korea1-0.ab6029ff.js\",\"gA5f7\",\"Adobe-Korea1-1.f58d7af7.js\",\"i4Ed8\",\"Adobe-Korea1-2.90e46d21.js\",\"l6X7m\",\"Adobe-Korea1-UCS2.37651d5b.js\",\"aphLF\",\"B5-H.35e26a2d.js\",\"7EoeH\",\"B5-V.af3f0204.js\",\"6Q7ZY\",\"B5pc-H.e4f1d7a8.js\",\"8cnq9\",\"B5pc-V.8f5377c3.js\",\"7NcV5\",\"CNS-EUC-H.6bb831b5.js\",\"cxpt9\",\"CNS-EUC-V.8c378414.js\",\"l27ve\",\"CNS1-H.ea7d046f.js\",\"c6rCW\",\"CNS1-V.1fdf3e4e.js\",\"3upsV\",\"CNS2-H.705fd9e8.js\",\"k9G9k\",\"CNS2-V.c55f4d63.js\",\"bDgpL\",\"ETHK-B5-H.7f8e45d5.js\",\"33eqd\",\"ETHK-B5-V.09bf3c22.js\",\"5F3PA\",\"ETen-B5-H.05fb1408.js\",\"hfiT2\",\"ETen-B5-V.5e380c42.js\",\"jMuj8\",\"ETenms-B5-H.3891364b.js\",\"gNTCu\",\"ETenms-B5-V.394705ca.js\",\"6rTQb\",\"EUC-H.b991c232.js\",\"l89SH\",\"EUC-V.0ac4677e.js\",\"iEkij\",\"Ext-H.5968bae5.js\",\"eVVKx\",\"Ext-RKSJ-H.d9938a5e.js\",\"kL3q4\",\"Ext-RKSJ-V.e9a51cbe.js\",\"avDfo\",\"Ext-V.74d1f996.js\",\"l3LgN\",\"GB-EUC-H.910bba6d.js\",\"eIBS8\",\"GB-EUC-V.0c6edfac.js\",\"8HXb3\",\"GB-H.92bed904.js\",\"lWK2A\",\"GB-V.4564569a.js\",\"iYIwI\",\"GBK-EUC-H.f5f68a8f.js\",\"g4Lp1\",\"GBK-EUC-V.97682197.js\",\"9jlRI\",\"GBK2K-H.edc4a051.js\",\"g2IgM\",\"GBK2K-V.46c62554.js\",\"24SBU\",\"GBKp-EUC-H.da565c58.js\",\"gzU5W\",\"GBKp-EUC-V.d5927fe2.js\",\"jN4tb\",\"GBT-EUC-H.267ac8c0.js\",\"6fVUl\",\"GBT-EUC-V.7720b25f.js\",\"e0AMV\",\"GBT-H.974fe797.js\",\"htjXf\",\"GBT-V.12defd7a.js\",\"hWeIU\",\"GBTpc-EUC-H.43d524d7.js\",\"1eaMl\",\"GBTpc-EUC-V.c77ba0fc.js\",\"fDvqM\",\"GBpc-EUC-H.08408830.js\",\"2de5A\",\"GBpc-EUC-V.ddbe12a3.js\",\"19tEv\",\"H.8a76eaa0.js\",\"j0hRA\",\"HKdla-B5-H.e6a4bedb.js\",\"fd9qd\",\"HKdla-B5-V.94816590.js\",\"e9cdN\",\"HKdlb-B5-H.41238054.js\",\"aNHZK\",\"HKdlb-B5-V.c7a56f0d.js\",\"hgC4a\",\"HKgccs-B5-H.423aefeb.js\",\"eEaBv\",\"HKgccs-B5-V.fff775c8.js\",\"fYV0G\",\"HKm314-B5-H.60d4b9bb.js\",\"dJs80\",\"HKm314-B5-V.997bace9.js\",\"4Y1kq\",\"HKm471-B5-H.0a6f2053.js\",\"hYpsA\",\"HKm471-B5-V.5588cb3b.js\",\"9xkOt\",\"HKscs-B5-H.cbf6db19.js\",\"lm69C\",\"HKscs-B5-V.cf9a31dc.js\",\"kva4v\",\"Hankaku.ca0ba78b.js\",\"5AfTB\",\"Hiragana.85378b4a.js\",\"3TaY6\",\"KSC-EUC-H.aff5022e.js\",\"8wf7j\",\"KSC-EUC-V.3949c72d.js\",\"cgHyF\",\"KSC-H.4ed431c9.js\",\"cxq0E\",\"KSC-Johab-H.22d6dfec.js\",\"ipw37\",\"KSC-Johab-V.0ee59f70.js\",\"aD76K\",\"KSC-V.dc2b8859.js\",\"8okaY\",\"KSCms-UHC-H.b54f6070.js\",\"i7fxp\",\"KSCms-UHC-HW-H.998acbf6.js\",\"7fYMC\",\"KSCms-UHC-HW-V.0a3c59db.js\",\"imOx6\",\"KSCms-UHC-V.37c6be44.js\",\"gKF8I\",\"KSCpc-EUC-H.4cfc83d8.js\",\"9m5PS\",\"KSCpc-EUC-V.5881e143.js\",\"8asvD\",\"Katakana.321c2f5f.js\",\"7HkN3\",\"NWP-H.6a69fa60.js\",\"isnju\",\"NWP-V.88613bd5.js\",\"f31m2\",\"RKSJ-H.2af2abd8.js\",\"2VYvR\",\"RKSJ-V.65a07798.js\",\"1KF3Q\",\"Roman.ca13d8f3.js\",\"29QIq\",\"UniCNS-UCS2-H.f2596cac.js\",\"dVqyh\",\"UniCNS-UCS2-V.4be9430a.js\",\"7UKDA\",\"UniCNS-UTF16-H.bb71adc5.js\",\"Q9KG4\",\"UniCNS-UTF16-V.d89c4950.js\",\"c2z6B\",\"UniCNS-UTF32-H.6ef36f87.js\",\"lTznr\",\"UniCNS-UTF32-V.c838593e.js\",\"7t7V6\",\"UniCNS-UTF8-H.77d5771f.js\",\"lcMXU\",\"UniCNS-UTF8-V.70a7ba9f.js\",\"4Y11P\",\"UniGB-UCS2-H.1303e3c8.js\",\"6MnqR\",\"UniGB-UCS2-V.c4668ab1.js\",\"eQt1R\",\"UniGB-UTF16-H.d1be3be2.js\",\"fm8Lw\",\"UniGB-UTF16-V.a072ba07.js\",\"4l8L7\",\"UniGB-UTF32-H.e2d1c79f.js\",\"1tDis\",\"UniGB-UTF32-V.76c200be.js\",\"2Vv5T\",\"UniGB-UTF8-H.41f4baba.js\",\"iWa77\",\"UniGB-UTF8-V.8ed42052.js\",\"38Eab\",\"UniJIS-UCS2-H.e0c99f94.js\",\"lDeVy\",\"UniJIS-UCS2-HW-H.2086623a.js\",\"8aWy7\",\"UniJIS-UCS2-HW-V.ffb2caeb.js\",\"76QHL\",\"UniJIS-UCS2-V.21ffe4a5.js\",\"lRW10\",\"UniJIS-UTF16-H.4216604d.js\",\"aJpvy\",\"UniJIS-UTF16-V.48b4e738.js\",\"7s6rx\",\"UniJIS-UTF32-H.038159ea.js\",\"jUs4H\",\"UniJIS-UTF32-V.34681c47.js\",\"a8YIF\",\"UniJIS-UTF8-H.3f187918.js\",\"fH9Jk\",\"UniJIS-UTF8-V.dd6be6a0.js\",\"13MuZ\",\"UniJIS2004-UTF16-H.c4a60299.js\",\"hwfXT\",\"UniJIS2004-UTF16-V.2dbaf4f4.js\",\"dGSeC\",\"UniJIS2004-UTF32-H.dba66596.js\",\"9rrYA\",\"UniJIS2004-UTF32-V.74761cad.js\",\"7d1OI\",\"UniJIS2004-UTF8-H.4ec8549f.js\",\"809oM\",\"UniJIS2004-UTF8-V.c5cc5b20.js\",\"bdrR8\",\"UniJISPro-UCS2-HW-V.4031e777.js\",\"4D2EW\",\"UniJISPro-UCS2-V.5072efde.js\",\"cdY8a\",\"UniJISPro-UTF8-V.7adee45d.js\",\"avqzB\",\"UniJISX0213-UTF32-H.56363b94.js\",\"j845q\",\"UniJISX0213-UTF32-V.6e415ebf.js\",\"emImx\",\"UniJISX02132004-UTF32-H.80a3d411.js\",\"f6AOW\",\"UniJISX02132004-UTF32-V.75e044a9.js\",\"7pSug\",\"UniKS-UCS2-H.4ff5f169.js\",\"465mT\",\"UniKS-UCS2-V.af99e23d.js\",\"3w6Hd\",\"UniKS-UTF16-H.b031c3f9.js\",\"4T3rW\",\"UniKS-UTF16-V.dbaec3f8.js\",\"d8Hqs\",\"UniKS-UTF32-H.11f34035.js\",\"77ADK\",\"UniKS-UTF32-V.344d4ef0.js\",\"dkDCu\",\"UniKS-UTF8-H.a4bf67c4.js\",\"8Qdf7\",\"UniKS-UTF8-V.af9521f3.js\",\"bhNwf\",\"V.5ce814bb.js\",\"ioEN1\",\"WP-Symbol.9e3226a6.js\",\"hGXAt\",\"arrow-left.ed8cca79.js\",\"edP6u\",\"home.9c6d2e67.js\",\"2OhRQ\",\"codeViewerRenderer.29c899a3.js\",\"3wpjh\",\"image.4dcab477.js\",\"869mA\",\"video.143afd2a.js\",\"gn6fp\",\"video.9b8db9ab.js\",\"j7Vtd\",\"audio.ed422cca.js\",\"f33Ay\",\"doc.705867f0.js\",\"2JEgu\",\"codeViewer.42f6a723.js\",\"gQYJt\",\"svg.0f44db18.js\",\"9ldIR\",\"cardWithMediaClient.0751dbe9.js\",\"gFHfi\",\"zoom-out.db09cd7a.js\",\"4uhcp\",\"zoom-in.5852ad10.js\",\"doomh\",\"chevron-left-circle.db11b726.js\",\"lnWRh\",\"chevron-right-circle.2430a910.js\",\"8Ozg8\",\"inlinePlayer.a16f93aa.js\",\"9jsMO\",\"cardWithMediaClient.5a21fcb3.js\",\"k4PhO\",\"global-opt-in-default-image-banner.cf053e66.svg\",\"6aruy\",\"media-client-react.384a4b9e.js\",\"7XFs3\",\"QuickReload.f5089e05.js\",\"6tlHd\",\"image.0e0e5955.js\",\"dIuhJ\",\"link-filled.19c799b9.js\",\"e6bZt\",\"QuickReload.eb159ab8.js\",\"dGO6Y\",\"QuickReload.72745699.js\",\"gZUCP\",\"document.2a887e0e.js\",\"dsbZs\",\"video.60e0a213.js\",\"6iF9L\",\"root-component.109947e7.js\",\"6qah4\",\"atl.3b09241c.js\",\"jCu7l\",\"FullPageEditorComponent.b88a755d.js\",\"kB1sA\",\"FullPageEditorComponent.4197c049.js\",\"l40lY\",\"ufo.b5194478.js\",\"2HlAY\",\"root-component.6d1f6b33.js\",\"6cVEd\",\"fire-event.1cec89e8.js\",\"9p2N9\",\"ui.3def16a4.js\",\"hqblC\",\"browser.a82fcef7.js\",\"7oUma\",\"browser.77266374.js\",\"cCWZm\",\"dropzone.4493101a.js\",\"lE3cg\",\"media-picker-analytics-error-boundary.d8c605aa.js\",\"6XNSn\",\"codeBlockAdvanced.3e654bdb.js\",\"01BDc\",\"dist.f36f7d00.js\",\"jneCP\",\"dist.adf4c603.js\",\"3lBx7\",\"dist.82105929.js\",\"1EgQg\",\"dist.7c7ec582.js\",\"iWiJK\",\"dist.03768f8e.js\",\"gkT8b\",\"dist.11d30e66.js\",\"lLY5F\",\"dist.521fa1db.js\",\"7BCTg\",\"dist.daadd8cb.js\",\"jD4Pj\",\"dist.0c350558.js\",\"217bQ\",\"dist.563e7eec.js\",\"3AIgh\",\"dist.a75fea7a.js\",\"3WBDc\",\"dist.b344a93f.js\",\"gnPOt\",\"dist.761f9dfc.js\",\"73p2H\",\"dist.0397e21f.js\",\"22pEl\",\"dist.8b39c40c.js\",\"cgrQ3\",\"dist.a04ab887.js\",\"5BOC6\",\"dist.30663d49.js\",\"b3fvV\",\"dist.37416658.js\",\"ajqM4\",\"dist.9ab582a8.js\",\"jjPUS\",\"apl.b81e50f9.js\",\"h9FOd\",\"asciiarmor.8042d41d.js\",\"aCljb\",\"asn1.a9aaf8f7.js\",\"lE1F7\",\"asterisk.f4595367.js\",\"aXFnX\",\"brainfuck.4bd8ce2f.js\",\"gkO56\",\"cobol.30d0d372.js\",\"aXQyM\",\"clike.34bb1d46.js\",\"diAFJ\",\"clojure.21077391.js\",\"d7yTx\",\"css.3d1ff96e.js\",\"b2YDT\",\"cmake.0e3e455b.js\",\"4ga7U\",\"coffeescript.c2281a85.js\",\"cZ3D7\",\"commonlisp.97a06575.js\",\"qaaCs\",\"cypher.b80fd281.js\",\"9Fcz0\",\"python.f5111821.js\",\"6RZjl\",\"crystal.a0197265.js\",\"ji1Kk\",\"d.42c2683e.js\",\"2L5Mz\",\"diff.cdb11d67.js\",\"lmz4e\",\"dockerfile.70f43558.js\",\"814bh\",\"dtd.11778cc2.js\",\"7XVNh\",\"dylan.468e767f.js\",\"hGS6V\",\"ebnf.30d80091.js\",\"592ir\",\"ecl.5a273c1a.js\",\"hPiIc\",\"eiffel.85a912d8.js\",\"7wfVk\",\"elm.77c03e04.js\",\"ebMo8\",\"erlang.6dc9b335.js\",\"5h0BU\",\"sql.83903d9f.js\",\"bE4uu\",\"factor.91d4bca2.js\",\"7Mgt2\",\"fcl.8ab4c522.js\",\"bOI1J\",\"forth.3c528cb4.js\",\"bmWQh\",\"fortran.e0029ed4.js\",\"kHxTh\",\"mllike.153cf519.js\",\"6MC1n\",\"gas.a7bccbc7.js\",\"lNBbh\",\"gherkin.3957c5fc.js\",\"bYMjO\",\"groovy.2c7c6877.js\",\"kIBZl\",\"haskell.27501ac4.js\",\"3uMSv\",\"haxe.54a5898e.js\",\"9vuGq\",\"http.bc2057b4.js\",\"1eHix\",\"idl.b9661b63.js\",\"7kn4A\",\"javascript.398b6ea8.js\",\"j4qEZ\",\"jinja2.a602283d.js\",\"3ozoR\",\"julia.eb339e67.js\",\"3DTzS\",\"livescript.a061dc12.js\",\"hURlP\",\"lua.1771bd2a.js\",\"2gQjS\",\"mirc.df514b63.js\",\"hoU9b\",\"mathematica.4b8aab4c.js\",\"40pAI\",\"modelica.f8eb4cea.js\",\"i5YKF\",\"mumps.cf82c6f0.js\",\"hIeWi\",\"mbox.e4169567.js\",\"8q3KK\",\"nginx.5d266b03.js\",\"1VXLT\",\"nsis.e4e191fa.js\",\"bAq00\",\"ntriples.12b53fef.js\",\"aEtpl\",\"octave.05b71169.js\",\"hfTKk\",\"oz.0938f362.js\",\"hTqBJ\",\"pascal.39d89476.js\",\"5ukWe\",\"perl.52765d5b.js\",\"3XLd5\",\"pig.0fb008c2.js\",\"2QavN\",\"powershell.f53ac67c.js\",\"ch01A\",\"properties.ff60ea69.js\",\"7inaT\",\"protobuf.c983d409.js\",\"cJ7mc\",\"pug.9abece4a.js\",\"5NvMz\",\"puppet.b9ab89df.js\",\"ego66\",\"q.aaa15180.js\",\"hj2Rh\",\"r.0b08b779.js\",\"b7tzx\",\"rpm.685318b2.js\",\"3YkAH\",\"ruby.04bb2af8.js\",\"cf92i\",\"sas.9ff0311d.js\",\"8W2eu\",\"scheme.a36ef94c.js\",\"lcrbq\",\"shell.d5f15f17.js\",\"98Pr8\",\"sieve.f0f2cb2c.js\",\"9dDWH\",\"smalltalk.33729233.js\",\"lrUqt\",\"solr.21ea773c.js\",\"bfOqz\",\"sparql.554ff633.js\",\"glXdM\",\"spreadsheet.cd8b4101.js\",\"b9USS\",\"stylus.7e0a4e39.js\",\"kPthK\",\"swift.633d1fa8.js\",\"jsCJL\",\"stex.8d5212f6.js\",\"abYjx\",\"verilog.d22265d7.js\",\"d7Hao\",\"tcl.ced1f258.js\",\"axn6R\",\"textile.51355a0b.js\",\"jDwZc\",\"tiddlywiki.5e83d78f.js\",\"ejPOn\",\"tiki.6fb365f5.js\",\"jx5LN\",\"toml.84dc3c91.js\",\"lsrGy\",\"troff.f7dd2860.js\",\"caKW9\",\"ttcn.4a33ec37.js\",\"6cyuP\",\"ttcn-cfg.5ae2f58f.js\",\"kezEf\",\"turtle.ed16c466.js\",\"ec2k9\",\"webidl.32e06ad6.js\",\"gQivI\",\"vb.278bc558.js\",\"1MGG6\",\"vbscript.a342aecd.js\",\"19BgE\",\"velocity.40adbcac.js\",\"4QVhK\",\"vhdl.7cdb96b8.js\",\"5PTeQ\",\"xquery.27819ab6.js\",\"7rV3v\",\"yacas.6d63ee7e.js\",\"lzeGI\",\"z80.2e6d4d2e.js\",\"jZHIh\",\"mscgen.5ea5176c.js\",\"hLKFT\",\"dist.a9b48aa5.js\",\"4ZwHa\",\"dist.83c91e9c.js\",\"6qRJw\",\"dist.a90fea49.js\",\"1Wolg\",\"dist.b936756b.js\",\"fNNWn\",\"dist.e67d127a.js\",\"klDll\",\"PageHeaderLoomEntryPoint.ad80d3ed.js\",\"dLkMK\",\"CommentEditor.1584657a.js\",\"np2ZB\",\"NonMasteredUserModal.b580c3b6.js\",\"j2eUy\",\"nonMasteredUserModalSplashImage.90ba8397.svg\",\"hq1Iv\",\"masteringFlowSplashImage.1f9bd0cc.svg\",\"2a8Ft\",\"is-supported.2cc000b0.js\",\"cvmv4\",\"esm.9c824e21.js\",\"iLgOr\",\"FullPageEditorComponent.728447bb.js\",\"daoWf\",\"LoomCrossSellPopupCardImage.6e60c328.png\",\"jBwbI\",\"LoomMigrationModalManager.360bb567.js\",\"3jZMP\",\"loomMigrationModalImage.fa8ef03b.svg\",\"1wrZ9\",\"vector.07efb279.svg\",\"014Eq\",\"pageHeaderSpotlightImage.b1e98e59.png\",\"ipnbL\",\"createSpotlightImage.f64dc988.png\",\"eufZR\",\"CommentEditor.1e901fee.js\",\"3FT39\",\"cs.b4709f80.js\",\"7QoTg\",\"da.e788fd22.js\",\"d1Lrf\",\"de.2dd434ed.js\",\"kM5GB\",\"en_GB.82797faf.js\",\"5506N\",\"en_ZZ.a7c6e9ad.js\",\"7ioy0\",\"es.a4af58eb.js\",\"kZ6zs\",\"fi.aaa32cea.js\",\"phbpE\",\"fr.0e55ec47.js\",\"6pKhl\",\"hu.8153cc96.js\",\"hzLOt\",\"it.75418871.js\",\"1M8mW\",\"ja.6ef7e39a.js\",\"eHQAY\",\"ko.36b5b8ee.js\",\"8exPB\",\"nb.9e9e6a03.js\",\"knfAP\",\"nl.dbd0c739.js\",\"ljRXP\",\"pl.7932a8db.js\",\"bEb8c\",\"pt_BR.e2f7c972.js\",\"c7JYF\",\"ru.a2b7a11a.js\",\"ari8V\",\"sv.1d81f4cf.js\",\"kfrHX\",\"th.0d215dce.js\",\"aWToy\",\"tr.9415008a.js\",\"4ns5x\",\"uk.baa17c6e.js\",\"7bfAn\",\"vi.26b5754b.js\",\"gftgT\",\"zh_TW.b791e5b1.js\",\"6YVlG\",\"zh.ccb62d88.js\",\"3v4Cg\",\"CommentEditor.0b1fcb83.js\",\"6UnNI\",\"FullPageEditorComponent.515be4bc.js\",\"6wlp3\",\"FullPageEditorComponent.9eb3cffb.js\",\"7NttI\",\"attachment.df701af7.js\",\"8TJKv\",\"emoji.60e57f7b.js\",\"hoUEM\",\"simpleHasher.fb2f1c66.js\",\"grG1M\",\"settings.80265a34.js\",\"4JGdD\",\"mediaGroup.086303ef.js\",\"chR0R\",\"mediaInline.e694568c.js\",\"4M7W5\",\"mediaInlineCard.a3f5da37.js\",\"iP5Bv\",\"mediaInlineAnalyticsErrorBoundary.da71b2bb.js\",\"6AIMV\",\"mention.8ae8ef1e.js\",\"5Pnad\",\"cs.956703b3.js\",\"3qzeo\",\"da.a6e51006.js\",\"4UYlu\",\"de.0e52901f.js\",\"3qbnQ\",\"en.c857dc06.js\",\"HY4Vc\",\"en_GB.8088c875.js\",\"fJQPR\",\"en_ZZ.67fbfeed.js\",\"gxipV\",\"es.69f016fd.js\",\"3uZ1q\",\"et.ac1a0ae0.js\",\"ardvv\",\"fi.be067ec8.js\",\"cjhdF\",\"fr.498beda1.js\",\"2mWUI\",\"hu.c32b69d9.js\",\"29Sce\",\"is.02c33977.js\",\"dBvXj\",\"it.fbe42f1a.js\",\"gmdLX\",\"ja.3923bf19.js\",\"fcXn9\",\"ko.419acfa2.js\",\"lH0NU\",\"nb.082125cc.js\",\"3OEsN\",\"nl.7ba79509.js\",\"hGLdi\",\"pl.d68b8afc.js\",\"Xi5AP\",\"pt_BR.ea61b74c.js\",\"f7XHA\",\"pt_PT.e565d94b.js\",\"14AZs\",\"ro.699a99b7.js\",\"lsFbX\",\"ru.1a33c100.js\",\"ibz6c\",\"sk.b538319e.js\",\"7I8FK\",\"sv.e3c6634e.js\",\"l7PQP\",\"th.93fb5ab5.js\",\"4iSRl\",\"tr.0b957c49.js\",\"fLjHM\",\"uk.7a8159bb.js\",\"3YGga\",\"vi.a291c6ef.js\",\"7yGIa\",\"zh_TW.018b8e11.js\",\"dZksg\",\"zh.be550b65.js\",\"2lsX7\",\"main.1b7a934b.js\",\"St9Nk\",\"AgentProfileCard.1763c88e.js\",\"c9Qqc\",\"auto-dev.998d58bd.js\",\"1TK6P\",\"auto-fix.07790e95.js\",\"grvAy\",\"auto-review.eb6c556a.js\",\"23K0q\",\"backlog-buddy.77803ebe.js\",\"3kQkj\",\"comms-crafter.37031eba.js\",\"6OXgE\",\"culture.46528ca4.js\",\"cbucA\",\"customer-insight.b71811cb.js\",\"bVhr1\",\"decision-director.cdf61897.js\",\"kE0QC\",\"feature-flag-avatar.c60bd9d5.js\",\"eVFXf\",\"generic-avatar.0faf04ac.js\",\"9FhBz\",\"hire-writer.9e73f27f.js\",\"6zB8z\",\"marketing-message-maestro.d95d5d6b.js\",\"eENGY\",\"my-user-manual.277d400f.js\",\"hmlb0\",\"okr-oracle.501b2473.js\",\"2NGxc\",\"ops-agent.6b999ec1.js\",\"bPgcq\",\"pitch-perfector.33d8fc56.js\",\"31b1q\",\"product-requirement.2b164fec.js\",\"8Lh9U\",\"release-notes.c909e5c4.js\",\"6ZzYJ\",\"research-scout.6dccd2a5.js\",\"410SS\",\"social-media-scribe.404e9147.js\",\"z3s9q\",\"team-connection.62db7c27.js\",\"9gqcE\",\"workflow-builder.48a79198.js\",\"6ge9a\",\"mention.aec8d5bb.js\",\"he20F\",\"EndOfPageRecommendation.6b434f25.js\",\"dfBrb\",\"EndOfPageRecommendation.ccd2be62.js\",\"kQvbt\",\"PageLabelsAutomationDiscovery.34a068c7.js\",\"3JzPO\",\"WatchDialog.8618bca0.js\",\"kpHRm\",\"GeneralShortcutListener.744314f2.js\",\"3kHns\",\"WatchDialog.d2552132.js\",\"emd3r\",\"AISummaryFooter.01e5b737.js\",\"b0HBF\",\"CoreInvites.17b15726.js\",\"8hTWF\",\"FullPageEditorComponent.691ddee7.js\",\"hXu5I\",\"plussquare.b31ea70a.js\",\"kkycx\",\"issue-raise.75748e61.js\",\"7lyIx\",\"page.d018348a.js\",\"esvqD\",\"page.e19a2d78.js\",\"a0oMZ\",\"ui.2de8e893.js\",\"i1TuF\",\"cs.2190cb07.js\",\"eEPT4\",\"da.02eaca38.js\",\"gkfGT\",\"de.90355bf8.js\",\"6kSRw\",\"en.32193a4b.js\",\"2dFTF\",\"en_GB.09598cb2.js\",\"auo6z\",\"en_ZZ.f14ca7c2.js\",\"685rk\",\"es.8fa0593c.js\",\"fp6pG\",\"fi.71fd59df.js\",\"6bt8l\",\"fr.40c5717d.js\",\"jjvsl\",\"hu.50ccd7da.js\",\"bAfbH\",\"it.e0e7a6ba.js\",\"5Q9X0\",\"ja.2dfec41f.js\",\"ePkyJ\",\"ko.0b1ec89d.js\",\"hpdFn\",\"nb.b2e768d2.js\",\"8qW90\",\"nl.7f781ad8.js\",\"a1OSV\",\"pl.ca25a045.js\",\"8AvOI\",\"pt_BR.eb536358.js\",\"jxu37\",\"ru.3bbb4cd9.js\",\"10YQF\",\"sv.b02b2c4a.js\",\"daBgp\",\"tr.1172519d.js\",\"bI6N0\",\"th.b72c3249.js\",\"3Qhls\",\"uk.c5a9160e.js\",\"dgXIC\",\"vi.98dce50e.js\",\"jh4hi\",\"zh_TW.79a7157d.js\",\"2AL0H\",\"zh.29b1c23a.js\",\"iaptT\",\"Page.1a916992.js\",\"kG8pF\",\"ViewPage.cd45a9bd.js\",\"1Rd9w\",\"ViewPage.e3a6628d.js\",\"4YF8c\",\"EditPage.b70b1cd5.js\",\"6kvlj\",\"FullPageEditorComponent.386c78e2.js\",\"gGI57\",\"Page.43016ef1.js\",\"8KDBK\",\"inline-create-one-step-experiment.c2c056f4.js\",\"6qsEc\",\"FullPageEditorComponent.467909db.js\",\"dnE79\",\"editor-ai-opt-in-banner.523b2454.svg\",\"6z3SN\",\"BrowseRovoAgentsModal.6861a64c.js\",\"gXUq7\",\"AgentProfileCard.dd52ab6b.js\",\"erM4f\",\"star-filled.1f795fb2.js\",\"6FSEq\",\"star.e20ad96e.js\",\"g2v3v\",\"BrowseRovoAgentsModal.b28be49d.js\",\"iwtoQ\",\"BrowseRovoAgentsModal.2c5cdc78.js\",\"g7pmM\",\"suitcase.3354a23a.js\",\"hvXzR\",\"FullPageEditorComponent.eaa8b625.js\",\"bku9v\",\"CommentEditor.2f7361a4.js\",\"hwHcA\",\"FullPageEditorComponent.57e0bc25.js\",\"jcdL6\",\"action.0a8137c7.js\",\"8SMhH\",\"code.d6b8067d.js\",\"bxYOE\",\"date.03e54c47.js\",\"f0zmS\",\"decision.b0f74b53.js\",\"ggLwo\",\"divider.ee99e8cc.js\",\"1p2DU\",\"emoji.e542ebd5.js\",\"1RKLZ\",\"images.50557af0.js\",\"7i9aD\",\"layout.896ff24e.js\",\"4VRIj\",\"link.4c2afa22.js\",\"djSOz\",\"list-number.87b71c46.js\",\"irpaz\",\"list.eaa0868a.js\",\"3SeOO\",\"mention.9cfda511.js\",\"5se79\",\"panel-error.62057b3d.js\",\"9bXCA\",\"panel-note.59120c9e.js\",\"1WrE2\",\"panel-success.58f0ef3b.js\",\"fnpAC\",\"panel-warning.cacb4e29.js\",\"gMSS1\",\"panel.e9156a35.js\",\"e1MXN\",\"quote.b63af4e1.js\",\"4dn8m\",\"status.1d7beedc.js\",\"9E19j\",\"one-column-layout.7347bd62.js\",\"bDOK7\",\"two-column-layout.d12f3568.js\",\"jhuLr\",\"three-column-layout.08b99461.js\",\"gMvtj\",\"four-column-layout.5a85aae9.js\",\"7unhY\",\"five-column-layout.78208ad9.js\",\"aKgoC\",\"heading1.146cf77d.js\",\"9ygQy\",\"heading2.db1ef0b8.js\",\"kTaDo\",\"heading3.d5d438f3.js\",\"d2kuO\",\"heading4.4c9e1386.js\",\"6wLYX\",\"heading5.bfeb0683.js\",\"eVKfF\",\"heading6.7fd49ad3.js\",\"b4NwV\",\"feedback.7c2aec31.js\",\"h9aqE\",\"expand.183cbdea.js\",\"jXrdN\",\"datasource-jira-issue.ed2ea567.js\",\"9Bneg\",\"datasource-assets-objects.57e99865.js\",\"1lXr0\",\"datasource-confluence-search.7f39cb19.js\",\"bHGMG\",\"loom.6ed25479.js\",\"aA6N2\",\"Toolbar.79212adb.js\",\"26Id4\",\"FullPageEditorComponent.c5f9d1ff.js\",\"g7U6A\",\"CommentEditor.233799c7.js\",\"1ugoC\",\"FullPageEditorComponent.f5003152.js\",\"iAspJ\",\"FullPageEditorComponent.073ff4d4.js\",\"deN0E\",\"FullPageEditorComponent.0e7650f2.js\",\"cKARL\",\"FullPageEditorComponent.7d0b54cc.js\",\"5WLpx\",\"ElementBrowser.d52c154a.js\",\"1phY7\",\"text-style.b3b9d62b.js\",\"5z0ZJ\",\"FullPageEditorComponent.836e59dd.js\",\"boDjZ\",\"FullPageEditorComponent.69cb54a9.js\",\"2KkrK\",\"unlink.00b7ffcc.js\",\"awc2s\",\"CommentEditor.9579d313.js\",\"c0JsV\",\"link-picker.ee08f5bd.js\",\"gQSWJ\",\"chevron-right.63dc8531.js\",\"dBjkU\",\"add.25715708.js\",\"avCUM\",\"chevron-left.d78b2f60.js\",\"bgvYl\",\"cs.4ba470ca.js\",\"b39oP\",\"da.2757cc56.js\",\"aeErk\",\"de.e9d905c4.js\",\"kDs7y\",\"en_GB.3b8003b8.js\",\"jp5mX\",\"en_ZZ.f4a8a349.js\",\"aWhd2\",\"es.51161513.js\",\"j7gH4\",\"fi.f27ca3d6.js\",\"bqAzS\",\"fr.4dc9bdc1.js\",\"9i8rS\",\"hu.aca870b5.js\",\"dJLWv\",\"it.747f4681.js\",\"kWbs6\",\"ja.931e2d18.js\",\"835WZ\",\"ko.7d5a17a6.js\",\"d6wjH\",\"nb.37a856d1.js\",\"lk62y\",\"nl.63491589.js\",\"dJiiw\",\"pl.37a82474.js\",\"igUcR\",\"pt_BR.4d87c8f0.js\",\"clhk4\",\"ru.008210fc.js\",\"drGhL\",\"sv.8bb6f6e5.js\",\"jYGxH\",\"th.939e2134.js\",\"czAFw\",\"tr.0337f418.js\",\"c0Efy\",\"uk.44959921.js\",\"dKBuH\",\"vi.0a0fe683.js\",\"7eCND\",\"zh_TW.4675a2ac.js\",\"8SArD\",\"zh.ac524d15.js\",\"lN5yU\",\"FullPageEditorComponent.62d8211a.js\",\"laQtb\",\"CommentEditor.d8dcb713.js\",\"jrNlW\",\"FullPageEditorComponent.f2ccd67b.js\",\"g5HUX\",\"CommentEditor.eecfd405.js\",\"1S9KM\",\"lock-locked--lock-circle.ea8816e0.js\",\"bL008\",\"lock-circle.fdb473df.js\",\"1HhHN\",\"layout-three-equal.e4c78483.js\",\"f552O\",\"FullPageEditorComponent.164ce12e.js\",\"aT3AM\",\"FullPageEditorComponent.dd88b003.js\",\"5doAZ\",\"DatePicker.c6742099.js\",\"9KJWc\",\"clipboard.b68201c0.js\",\"iV231\",\"FullPageEditorComponent.df2f8d14.js\",\"44W0y\",\"FullPageEditorComponent.64bf63c9.js\",\"h9hWQ\",\"SimpleEmoji.0213c7c9.js\",\"griel\",\"FullPageEditorComponent.5e0b73f9.js\",\"1Xmqp\",\"upload.11b4f07d.js\",\"iLLJH\",\"CommentEditor.cda85758.js\",\"1dMfP\",\"background-color.44c67bcd.js\",\"1LhCD\",\"FullPageEditorComponent.f4bccf9c.js\",\"7CC0b\",\"FullPageEditorComponent.6dd68ca2.js\",\"b886X\",\"FullPageEditorComponent.3b2edb9e.js\",\"dclpt\",\"FullPageEditorComponent.e816fd31.js\",\"2u53D\",\"CommentEditor.84690835.js\",\"2KJHS\",\"esm.90a6c55b.js\",\"7jwEY\",\"esm.91f26d0a.js\",\"jdeAV\",\"esm.2443d5bd.js\",\"5FMP1\",\"FullPageEditorComponent.4954768b.js\",\"1kbPS\",\"FullPageEditorComponent.0f340c58.js\",\"77ceh\",\"definition-popup-content.088bbcf8.js\",\"6Z8WE\",\"en.db41dfb5.js\",\"aTu7U\",\"code.7aff7dd9.js\",\"eHVyt\",\"bullet-list.a692487e.js\",\"3NE3l\",\"remove.75824065.js\",\"dUEf9\",\"location.b2899cd9.js\",\"6Nh0d\",\"feedback.7e852256.js\",\"hYWtF\",\"open.486a5167.js\",\"jWA2N\",\"FullPageEditorComponent.db5d8c07.js\",\"jr5ZC\",\"FullPageEditorComponent.cfa66297.js\",\"iabhK\",\"preferences.92de3054.js\",\"iRpFz\",\"expand.08be709f.js\",\"3JJHk\",\"collapse.401834a6.js\",\"eruLw\",\"link.8814f015.js\",\"8oWxD\",\"grid.eabdea37.js\",\"e65TP\",\"redo.219506a9.js\",\"hWdy3\",\"undo.6b8e4386.js\",\"42Txt\",\"number-list.a6d08fef.js\",\"9aAXz\",\"outdent.60811ec4.js\",\"3oVYt\",\"indent.dc6fba28.js\",\"7JX0n\",\"italic.92ea6216.js\",\"9jfSP\",\"bold.6287e919.js\",\"6BjKx\",\"definition-popup-content.49599034.js\",\"EfTik\",\"hoverCard.1d111c22.js\",\"lb9xb\",\"smart-card.b29b3049.js\",\"cPSQq\",\"renderer.0a0ea708.js\",\"j4gWN\",\"HelpPanel.a76e4289.js\",\"ecOVI\",\"HelpPanel.ca5f8c58.js\",\"giPb3\",\"HelpPanel.runtime.dd19ddd0.js\",\"giPb3\",\"HelpPanel.runtime.dd19ddd0.js\",\"9tyrK\",\"react-markdown.8ea69fa2.js\",\"6PtxN\",\"cs.4af6da41.js\",\"8RKtn\",\"da.00cc494f.js\",\"fCIoO\",\"de.feb55cf0.js\",\"1geBW\",\"es.2b9a509c.js\",\"5WU5D\",\"et.c12c2abb.js\",\"i1Uow\",\"fi.577f953a.js\",\"3ZuKT\",\"fr.6da7024a.js\",\"5nJlY\",\"hu.3d953190.js\",\"Uq5C2\",\"it.d747a7e7.js\",\"9TzAL\",\"ja.6cac578c.js\",\"oPAjm\",\"ko.e5176471.js\",\"3fvcK\",\"nb.cf4f3e33.js\",\"iMYDs\",\"nl.0646b6ed.js\",\"jPHqC\",\"pl.7e10aa61.js\",\"3saM6\",\"pt_BR.2e845e69.js\",\"4hCdo\",\"pt_PT.3585f16f.js\",\"78gs3\",\"ru.6f4b63fe.js\",\"2XhMA\",\"sk.9b031399.js\",\"f7Egw\",\"sv.567af81d.js\",\"aiZUj\",\"tr.5656666a.js\",\"6rH3p\",\"th.f0261be3.js\",\"lS1VG\",\"uk.fe1da325.js\",\"fFbe4\",\"vi.32dd8df9.js\",\"7JTjB\",\"zh_TW.3a48b1fe.js\",\"dMjyc\",\"zh.37507780.js\",\"kg7uf\",\"definition-popup-content.9f2e181e.js\",\"fhU7k\",\"esm.50a6c5c3.js\",\"c7DhJ\",\"department.6ce9c430.js\",\"ej4rO\",\"definition-popup-content.bc7e2f46.js\",\"lnKog\",\"main.6dc51979.js\",\"avRkh\",\"ReadingAidsPopup.26214354.js\",\"ekztv\",\"office-building.1f9fed02.js\",\"3zuUe\",\"quote.693704ee.js\",\"63hQz\",\"documents.dbe23a7f.js\",\"dPdkf\",\"file.9fecbbb3.js\",\"hOsjc\",\"ResolvedInlineCommentsDialog.4510e840.js\",\"km34l\",\"ResolvedInlineCommentsQueryRenderer.92a4bfa8.js\",\"aS96v\",\"ResolvedInlineCommentsCounter.9d8431fc.js\",\"4xLT8\",\"FullPageEditorComponent.d1b82a07.js\",\"c2N7V\",\"FullPageEditorComponent.runtime.86cfde4d.js\",\"izTVQ\",\"FullPageEditorComponent.0d1cab6c.js\",\"d7AfU\",\"MainButtons.66cde31c.js\",\"dJQEi\",\"HelpPanel.91d66d32.js\",\"fEx3B\",\"HelpPanel.runtime.ecc2b67d.js\",\"U7y88\",\"HelpPanel.696715f7.js\",\"3JWH2\",\"TemplatePreview.5d820bdc.js\",\"5wcLJ\",\"ContextualCreateContentPopoverMenu.b3bc308a.js\",\"410C5\",\"ContextualCreateContentPopoverMenu.ad147009.js\",\"g9CVe\",\"mention.28df720c.js\",\"2JlZe\",\"file.3b99c234.js\",\"h4Nf7\",\"ExternalUserLozenge.2b3237f1.js\",\"2nuqm\",\"HelpPanel.872b9593.js\",\"26IOy\",\"HelpPanel.runtime.c92d52de.js\",\"5tHTv\",\"mention.a4a4d010.js\",\"2YKx2\",\"FullPageEditorComponent.e3d2dce4.js\",\"ipTFT\",\"EndOfPageRecommendation.134ca805.js\",\"eCgOQ\",\"EndOfPageRecommendation.7e130d77.js\",\"3TNOq\",\"EndOfPageRecommendation.d88d526e.js\",\"ev7SX\",\"GroupAndUserItem.96ef08cd.js\",\"f96v0\",\"FullPageEditorComponent.18c34476.js\",\"4tUsp\",\"PageLabelsAutomationDiscovery.bd11780b.js\",\"fQ1rW\",\"PageLabelsAutomationDiscovery.260d03bd.js\",\"jQFGH\",\"PageLabelsAutomationDiscovery.runtime.6f7ba595.js\",\"7kdzx\",\"EndOfPageRecommendation.a004e553.js\",\"ac6oS\",\"QuickSummaryPopup.16ba3b49.js\",\"h7Fyj\",\"quick_summary_spotlight.2a439c01.gif\",\"jrchu\",\"QuickSummaryStreamingEntryPoint.06fe79bb.js\",\"kUbT8\",\"AISummaryFooter.c0e5951c.js\",\"hcY7w\",\"SmartsSummaryErrorComponent.3767d907.js\",\"gO8Rd\",\"QuickSummaryStreamingEntryPoint.36c2fcfb.js\",\"hOsvD\",\"QuickSummaryStreamingEntryPoint.17c36986.js\",\"9X5xA\",\"quickSummaryUpsellBannerLight.edcc3647.svg\",\"iLB51\",\"quickSummaryUpsellBannerDark.e27429f6.svg\",\"gkmZg\",\"DevToolsDialog.496ffa12.js\",\"9RmPP\",\"FullPageEditorComponent.247f0be1.js\",\"fNKzh\",\"FullPageEditorComponent.runtime.e8b77f79.js\",\"UsGIB\",\"FullPageEditorComponent.9a460526.js\",\"bLKsM\",\"FullPageEditorComponent.runtime.d1ec9b00.js\",\"jdmfD\",\"ObjectSidebarControl.31afa70e.js\",\"j2I3I\",\"CreateComponent.53d12b58.js\",\"a37ke\",\"CreateComponent.b7c25367.js\",\"f7f51\",\"Comment.cfb2fef7.js\",\"hsCH6\",\"PageContentRendererFabric.1cdcfb0f.js\",\"68WuS\",\"EditorObjectSidebarPanel.d7d2e8ef.js\",\"gr9Xf\",\"ObjectSidebarPanelWrapper.664ba4b6.js\",\"1TkAG\",\"IndentIcon.798032fb.js\",\"aLenh\",\"LiveDocSpotlightsTour.8c62f954.js\",\"aJJUY\",\"FullPageEditorComponent.ce7eb793.js\",\"b6JBs\",\"CompanyHubBreadcrumbs.987b9468.js\",\"lpcEN\",\"ChangeHubNameDialog.b30dad73.js\",\"70fET\",\"hub-hero-image.d6790ccb.png\",\"1GyAj\",\"BreadcrumbsDropdownContent.cabb3e37.js\",\"36rXN\",\"MovePageDialog.1ab06876.js\",\"lnCW7\",\"ExternalCollaboratorInSpaceNotify.0768fceb.js\",\"j02A7\",\"ViewExternalCollaboratorsLink.aaaf4419.js\",\"l5XQ1\",\"ViewSpaceExternalCollaboratorsDialog.a2be6192.js\",\"hA2SB\",\"GroupAndUserItem.475503a1.js\",\"hwiu3\",\"NavigationLockout.6ac66ad3.js\",\"iHlO3\",\"empty-filter.16dda5ac.svg\",\"j4POW\",\"GroupAndUserItem.05c3b52c.js\",\"lookM\",\"user-header-for-space-with-guests-Light.1b10bf7d.svg\",\"2GHvs\",\"user-header-for-space-with-guests-Dark.3d8c1f10.svg\",\"ltXeo\",\"PageTree.5c026ca8.js\",\"dviIw\",\"CollapsibleSection.0c6f5543.js\",\"dkv9z\",\"PageTreeAfterIcon.0b67d19d.js\",\"9F7vX\",\"CreateContentPopover.a71986e9.js\",\"bAbyV\",\"top-nav.c1daa6bf.js\",\"f1WN5\",\"top-nav.f88e759b.js\",\"dwffN\",\"GlobalCreateContentPopoverMenu.0a91e12e.js\",\"iUB8p\",\"WhiteboardsPaywall.cf2c63af.svg\",\"1TlSS\",\"WhiteboardsPaywallDark.0948bce6.svg\",\"kiDFE\",\"CreateSpaceMenuItem.096139ba.js\",\"7xv66\",\"ContentTreeOnboarding.8453467e.js\",\"6fU2k\",\"drag-handle.0db4b120.js\",\"lWi9V\",\"CreateSpaceMenuItemNav3.1b2a8415.js\",\"3tVyh\",\"CreateSpacePlusButton.09a41ede.js\",\"hqYks\",\"ContextualCreateContentPopoverMenu.846e1799.js\",\"hr1db\",\"DatabaseGAOnboarding.fdc4cc79.svg\",\"h4qu8\",\"LiveDocsIntroGif.d2fc0787.gif\",\"j7hKO\",\"LiveDocIntroGADark.45e6357d.svg\",\"7yu5V\",\"LiveDocIntroGALight.8a32f41a.svg\",\"5TJ4V\",\"WhiteboardExperimentSpotlightImage.49c94c1b.svg\",\"e9W8R\",\"ContextualCreateContentPopoverMenu.34c3b54b.js\",\"cp1n9\",\"TreeBottomCreateButton.f7c79e48.js\",\"4Dabn\",\"ContextualCreateContentPopoverMenu.8ba240ee.js\",\"5Ixal\",\"CreateFolderPopoverItemSpotlight.0dc0692c.svg\",\"jzQ6f\",\"BlankPageQuickActions.03ed7586.js\",\"70aiP\",\"CreateFromTemplate.994a16f9.js\",\"7orLM\",\"ContextualCreateContentPopoverMenu.e0516aaf.js\",\"16ht2\",\"CreateFromTemplate.ed65e7b4.js\",\"hvHZS\",\"TemplatePreview.2b6344f0.js\",\"6JdS4\",\"blogPostIcon.e3cb4562.svg\",\"5fnDv\",\"loadingErrorIcon.3c97c605.svg\",\"bupWa\",\"PopupPreview.80faafe6.js\",\"3yGMH\",\"displayErrorIcon.3bd706b2.svg\",\"e1cuZ\",\"CreateFromTemplate.94c72e07.js\",\"4NgYy\",\"ContextualCreateContentPopoverMenu.2ada1402.js\",\"fEx3B\",\"HelpPanel.runtime.ecc2b67d.js\",\"clpSH\",\"PageTreeQuickActions.e8546650.js\",\"13PnU\",\"QuickActionsContent.e1a90149.js\",\"kSVGa\",\"ChangeEditionNotificationDialog.33ef1cc4.js\",\"6rpul\",\"ArchivedPageBannerV2.1acdf71b.js\",\"dxDVc\",\"UnarchivePagesLoader.bee886f9.js\",\"ktyyJ\",\"TrialFlags.71a606b8.js\",\"cmcKh\",\"TrialFlags.0d9edc2f.js\",\"4yUSc\",\"PremiumLozenge.7f341587.js\",\"ePA5l\",\"Lozenge.acf8f68b.js\",\"cPGpO\",\"premiumLozenge.aa9b0435.svg\",\"fqBFU\",\"ReverseTrialLozenge.25f08ee1.js\",\"1HAEl\",\"ReverseTrialListItem.7005fb08.js\",\"2Fobu\",\"EndOfPageRecommendation.f21c7089.js\",\"4gtMV\",\"EndOfPageRecommendation.718753bc.js\",\"djzzD\",\"PageLabelsAutomationDiscovery.9f37031d.js\",\"jQFGH\",\"PageLabelsAutomationDiscovery.runtime.6f7ba595.js\",\"f7WA2\",\"SlackDiscoveryDialog.6a266042.js\",\"eRzO9\",\"BulkChangePageOwnerDialog.c41a5707.js\",\"1rMtp\",\"PagePublishAutomationDiscoveryDialog.84059290.js\",\"jdEwy\",\"JiraLinkAutomationDiscoveryDialog.7b540e10.js\",\"696ho\",\"WhiteBoardPublishDiscoveryDialog.06bf0fa3.js\",\"1NKZf\",\"AutomationDiscoveryHoverPageTitleMessage.3c5d92e1.js\",\"6sAbi\",\"ArchivePageAutomationDiscovery.47c05680.js\",\"11AeH\",\"AutomationDiscoveryHeader.6db01409.svg\",\"77pyi\",\"SmartButtonConfigPanel.26bb5581.js\",\"7WcBh\",\"MovePageDialog.14f200be.js\",\"cQ2OK\",\"UnarchivePagesLoader.e33d1fa0.js\",\"kDklq\",\"UnarchivePagesLoader.226173ce.js\",\"50LrB\",\"UnarchivePagesLoader.1cc54032.js\",\"khV58\",\"PageSelectionTable.3fdafc93.js\",\"in6Mc\",\"NoChildrenBullet.077cc505.js\",\"bm3DR\",\"EmptyPageSelectionTable.28a091d1.js\",\"5IFtr\",\"fileCabinet.8e8cc872.svg\",\"2HL52\",\"QuickActionMenuBase.69e7a0c8.js\",\"8eNS3\",\"UnarchivePagesLoader.b9ace4c6.js\",\"awXdT\",\"error.b6351f9e.svg\",\"aOpoD\",\"empty-automation-list.9c7d0496.png\",\"bKdog\",\"UnarchivePagesLoader.5bf69011.js\",\"7dkWW\",\"ArchivedPageBannerV2.a096864c.js\",\"3uux1\",\"ArchivePagesLoader.3802a0ac.js\",\"cPaXL\",\"ArchiveUpsellDialog.6b2a698a.js\",\"7rEYM\",\"ShareButton.c51e41f3.js\",\"anGwD\",\"BulkArchivePagesLoader.99e861b6.js\",\"f0OaY\",\"ArchiveRemoteProcessContainer.f5f2a8e8.js\",\"hVNnP\",\"UpdateArchivedPageNoteDialog.80290d9b.js\",\"9QyoN\",\"PageQuickActionAutomationMenu.5c9fba59.js\",\"kCTMZ\",\"PageQuickActionAutomationMenu.0d873bbd.js\",\"9YGIy\",\"DeleteNestedPagesAction.045cf15d.js\",\"iomzR\",\"DeletePageDialog.e012436c.js\",\"k3BGs\",\"DeleteNestedPagesAction.5f058aca.js\",\"adHzf\",\"DeleteNestedPagesAction.af5a528e.js\",\"4JUnA\",\"BulkDeletePagesAction.c227b7ee.js\",\"5YvMC\",\"BulkChangeOwnerAction.5966b8a6.js\",\"bXkeF\",\"BulkChangeStatusAction.96a399d1.js\",\"leIbB\",\"BulkChangeStatusAction.2065de51.js\",\"1aFR7\",\"NestedChangeOwnerAction.f26438dc.js\",\"Pp5sV\",\"NestedConvertPageToLiveDocAction.9804acc9.js\",\"lgZ1d\",\"BulkConvertPageToLiveDocAction.dc529516.js\",\"p4ay7\",\"CopyPageTreeContainer.d2b3c6b9.js\",\"i5Fj1\",\"data-classification.9da6d04f.js\",\"jnk96\",\"DataClassification.65cff132.js\",\"gEi5K\",\"NotFound.95938568.js\",\"QfEJc\",\"NotFoundIcon.ab9d1086.svg\",\"bn8Oy\",\"OverviewNotFound.1b32739e.js\",\"4jFyQ\",\"icon-space-overview-empty.106059f9.svg\",\"3b99S\",\"EditorContentClassificationTag.d9726fb7.js\",\"1zPhe\",\"EditorDataClassification.d164af03.js\",\"avzJW\",\"EditorDataClassificationComponent.ac2525c4.js\",\"4Oj5y\",\"ContentTypeClassification.4e6b4f1b.js\",\"iJsKa\",\"ClassificationReadViewPopup.916ee61f.js\",\"cEDfx\",\"DataClassificationHoverButton.229e6e5c.js\",\"9wTW2\",\"EditorClassificationTagWrapper.f24b8d90.js\",\"hY77v\",\"FullPageEditorComponent.911c5569.js\",\"1ZoPC\",\"MovePageDialog.b653185d.js\",\"5odbj\",\"ClassificationTagButtonError.1b9558b9.js\",\"4Qstt\",\"ClassificationEditModal.928a4a72.js\",\"58UdM\",\"ClassificationEditViewPopup.c3b1a30d.js\",\"fOLlY\",\"MovePageDialog.49b1025c.js\",\"f9QHk\",\"TreeMonitor.3caa2a6d.js\",\"9PeA0\",\"GrantAccessDialog.4d31c2b0.js\",\"4mWJk\",\"GrantAccessFlag.cf1898b6.js\",\"bfhXH\",\"RestrictionsButton.c155fd56.js\",\"lk4cE\",\"RequestAccessPopup.4423d1e2.js\",\"TpLgp\",\"Controller.e2040fde.js\",\"fnUik\",\"GeneralAccessLevelSelector.94502818.js\",\"kxRVH\",\"AccessRequestsButton.8f6ff07e.js\",\"Ohbxv\",\"PublicLinkPermissionsSpotlight.328990b4.svg\",\"gjKgt\",\"PublicLinkButtonSpotlight.9320b1e3.svg\",\"k0hwN\",\"ShareToSlack.2f1b374a.js\",\"lVO4z\",\"cs.66d17b1d.js\",\"2FVbf\",\"da.45f5bf76.js\",\"ljo6M\",\"de.87ff8d2a.js\",\"9lT7a\",\"en_GB.3f736bc3.js\",\"cNgJs\",\"en.53674b7a.js\",\"aHeMo\",\"en_ZZ.90d281af.js\",\"8d6ia\",\"es.44f7b6ae.js\",\"jh8UJ\",\"fi.bd46bce1.js\",\"bYwCr\",\"fr.854524fc.js\",\"11NiT\",\"hu.21eb6dc5.js\",\"le8VA\",\"it.111da4a0.js\",\"1beJ2\",\"ja.25f13916.js\",\"1tXCh\",\"ko.c7b3c730.js\",\"jzP8g\",\"nb.6ab8a8d0.js\",\"dJY66\",\"nl.b11fd7f9.js\",\"4foYW\",\"pl.200ddf23.js\",\"j0yc3\",\"pt_BR.3fad7d31.js\",\"RfEmw\",\"ru.64b44490.js\",\"5DOlG\",\"sv.812498a9.js\",\"6rD7n\",\"tr.6280d059.js\",\"1e62a\",\"th.646e04f8.js\",\"eLsCU\",\"uk.87a103d8.js\",\"g9qHs\",\"vi.352e605d.js\",\"2ri5s\",\"zh_TW.40e2425f.js\",\"3k60n\",\"zh.af15c051.js\",\"hxIYN\",\"integration-primer.cead19d9.svg\",\"5oKDR\",\"disabled-alert.0ba0a4e5.svg\",\"13QWg\",\"in-trial-feature-gates-banner.0b6ee2bc.js\",\"85liN\",\"InspectPermissionsDialog.7b5d6af3.js\",\"14XOE\",\"InspectPermissionsDialog.efb1b661.js\",\"69XGw\",\"InspectPermissionsEntryPoint.446aa5ef.js\",\"8sFYu\",\"RestrictionsDialog.c0518aa4.js\",\"iO9O1\",\"personal_space.c63f5733.png\",\"gZKQW\",\"QuickActionsContent.144825d9.js\",\"fno6o\",\"RestrictionsDialogMountPoint.c537e8f1.js\",\"inQqk\",\"RestrictionsDialog.00a71866.js\",\"9NxYX\",\"no-restriction-illustration-Light.a376c323.svg\",\"lpZU0\",\"no-restriction-illustration-Dark.8da66227.svg\",\"kgrX3\",\"no-restriction-illustration-pencil-Light.bcc52320.svg\",\"bRk6k\",\"no-restriction-illustration-pencil-Dark.5e6368e9.svg\",\"1DRtS\",\"no-restrictions-illustration-external-share-Light.85b8ab71.svg\",\"hhpRR\",\"no-restrictions-illustration-external-share-Dark.dff9aa3b.svg\",\"42PSc\",\"AutomationPremiumTip.d204a3e0.js\",\"ipK41\",\"NativeCollabComponent.7adffda3.js\",\"3bo82\",\"ShareButton.0249141c.js\",\"hdBGO\",\"ShareButton.ca48f0c8.js\",\"jOlrD\",\"LazyShareForm.9e1502fb.js\",\"2jdQ1\",\"LazyShareFormNext.4990f2c2.js\",\"8M2wy\",\"LazyShareFormNext.f5498fb0.js\",\"k9kY4\",\"share.5b360985.js\",\"ew1CD\",\"ShareButtonLite.c5d7b4c9.js\",\"jle6Z\",\"premium.3b7fcb50.js\",\"2VACG\",\"RestrictionsUpsellDialog.f08f451c.js\",\"PNyg1\",\"InlineRename.b3f4eaa2.js\",\"2irg6\",\"MovePageDialog.45a8e765.js\",\"3L1uC\",\"PageTreeErrorComponent.b558e03e.js\",\"dhqJV\",\"FooterCreateButtons.31456e34.js\",\"67Pvd\",\"ContentTreeOnboarding.c1885794.js\",\"e19Zv\",\"LiveDocsIconTile.c4711bb6.js\",\"d1QkY\",\"TreeBottomCreateButton.8653d2d5.js\",\"fnoJZ\",\"HomepageIcon.129a4e5b.js\",\"6gau7\",\"DraftLozenge.83230e38.js\",\"5zDuS\",\"NativeCollabComponent.9b51ce27.js\",\"26IOy\",\"HelpPanel.runtime.c92d52de.js\",\"aoUod\",\"MoveBlogModal.36dafd44.js\",\"hHYS0\",\"ModernizedBreadcrumbsIndentIcon.be02b2bc.js\",\"hHIPg\",\"ObjectSidebarControl.583e609e.js\",\"4g8hn\",\"AIPresentationModalWrapper.e6ca36be.js\",\"3Eu7W\",\"drag-handler.79f2093f.js\",\"XdJi8\",\"AudioPanelErrorIllustration.24fce6d6.svg\",\"26kHw\",\"AudioPanelErrorIllustrationDark.fd4f5286.svg\",\"8S7hU\",\"ContentWrapperSpotlightGIF-dark.bbe9839d.gif\",\"7P169\",\"ContentWrapperSpotlightGIF-light.9900190e.gif\",\"1fnbu\",\"EditLabelDialogComponent.85cff8f9.js\",\"1kb22\",\"LabelsSelect.b02916d4.js\",\"5IJHO\",\"LabelsMovedChangeboarding.c40b90b4.js\",\"a7qwF\",\"LabelsSelectErrors.f971e59a.js\",\"fwFM0\",\"ViewPageLabels.fb57538f.js\",\"1MDpw\",\"AudioBriefingChangeboardingIllustration.3bcea83c.svg\",\"KSMZE\",\"ObjectSidebarSpotlightTour.4abb0f46.js\",\"gmwfN\",\"ModernizeChangeboarding.8ac5603b.js\",\"31kOm\",\"nav4GlobalSpotlightImage.b0eee534.svg\",\"dW3gq\",\"nav4GlobalSpotlightImageDark.46829a6e.svg\",\"1aHOD\",\"nav4SpaceSpotlightImage.8dc1626b.svg\",\"huVSt\",\"nav4SpaceSpotlightImageDark.eeaa5b5d.svg\",\"iXULO\",\"LiveDocModalGif-light.2404511f.gif\",\"ff6Qm\",\"LiveDocModalGif-dark.64c94d68.gif\",\"2nh75\",\"comment.6df2b630.js\",\"93PzR\",\"align-image-center.f5416e20.js\",\"9jXWv\",\"align-image-left.df489a97.js\",\"jCH24\",\"align-image-right.b11ed93a.js\",\"6pvRv\",\"media-wrap-left.cc70ef3b.js\",\"5oXE9\",\"media-wrap-right.f1e40e51.js\",\"5lvho\",\"media-wide.54b8d072.js\",\"cAsoy\",\"media-full-width.cdf78934.js\",\"lP8he\",\"ObjectSidebarControl.619866f3.js\",\"3pwml\",\"AIButtonSpotlight.ed733c2c.js\",\"bons8\",\"dark.6d30a270.svg\",\"1eGyz\",\"light.936b96f7.svg\",\"kYmQJ\",\"dark.90199792.svg\",\"150NM\",\"light.5ffcf568.svg\",\"7TxBG\",\"FullPageEditorComponent.05536137.js\",\"5VWLy\",\"FullPageEditorComponent.1ed76f7f.js\",\"anP9P\",\"error.5fbc7fe9.png\",\"4e15z\",\"ObjectSidebarControl.533ef1c8.js\",\"6cs5n\",\"FooterCommentsSummaryButton.02f02928.js\",\"5lfr5\",\"FooterCommentsSummaryCombined.6c97b686.js\",\"dsDqI\",\"ObjectSidebarControl.fbeec683.js\",\"gAIhR\",\"ObjectSidebarControl.97c2727f.js\",\"1FzbR\",\"RedactionsDialog.50afd0b7.js\",\"jrkFV\",\"ObjectSidebarControl.7447b819.js\",\"lKP6d\",\"GetTheDetailsYouNeedDark.bbe9839d.gif\",\"4Yi9K\",\"GetTheDetailsYouNeedLight.9900190e.gif\",\"jmPIf\",\"FullPageEditorComponent.4c81147d.js\",\"4gZEH\",\"FullPageEditorComponent.60479140.js\",\"iHZci\",\"FullPageEditorComponent.13a98d2b.js\",\"cqHdp\",\"addon.1cf94382.js\",\"jHDh2\",\"ContentTools.170658db.js\",\"9sm5T\",\"PageContentRendererFabric.ceca6094.js\",\"6vBO5\",\"CreateComponent.6eaa9e40.js\",\"acJUo\",\"ViewComponent.ccfaa5d0.js\",\"kaOf4\",\"PageContentRendererFabric.4114c89c.js\",\"3Kg3S\",\"CreateComponent.57e37b8f.js\",\"aHCaB\",\"ViewComponent.04a55ddf.js\",\"eh78s\",\"PageContentRendererFabric.aa6b2eb8.js\",\"hpN5y\",\"ForgeAction.b7749cd3.js\",\"eM4KW\",\"TextHighlighter.760e4f55.js\",\"bGzhS\",\"ByLineForgeApp.e1b2541d.js\",\"bf0yj\",\"modal-dialog.4a1551cd.js\",\"eMbal\",\"loading-button.90d63bac.js\",\"cjJTJ\",\"section-message.542a51ad.js\",\"jeyta\",\"no-results.603cf20f.svg\",\"is6uI\",\"FullPageEditorComponent.583103dc.js\",\"k7roz\",\"FullPageEditorComponent.runtime.6086ffa7.js\",\"f0WOR\",\"ByLineForgeApp.82489e3b.js\",\"k7roz\",\"FullPageEditorComponent.runtime.6086ffa7.js\",\"bdzih\",\"ContentActionForgeApp.1eac7c71.js\",\"cwpVK\",\"ContextMenuForgeApp.4c19f36d.js\",\"87cDu\",\"GlobalPageForgeApp.c08a2296.js\",\"iXr0W\",\"GlobalSettingsForgeApp.4c60acfc.js\",\"ccJug\",\"HomepageFeedForgeApp.126609de.js\",\"irYLY\",\"SpaceSettingsForgeApp.69e28f71.js\",\"ldtPf\",\"SpacePageForgeApp.7a40446b.js\",\"6wcNV\",\"CustomContentForgeApp.c36180cd.js\",\"i9jMB\",\"BackgroundScriptForgeApp.db36e8b6.js\",\"aFNXd\",\"PageBannerForgeApp.a7074cd9.js\",\"aSmvL\",\"DefinitionAction.eaebd0de.js\",\"kwiXK\",\"ReadingAidsChangeboardingModal.f3559eaa.js\",\"cF8dp\",\"changeboardingModalImage.516388c9.svg\",\"bLKsM\",\"FullPageEditorComponent.runtime.d1ec9b00.js\",\"c2N7V\",\"FullPageEditorComponent.runtime.86cfde4d.js\",\"fNKzh\",\"FullPageEditorComponent.runtime.e8b77f79.js\",\"i27dG\",\"EditorLoader.3f2979cd.js\",\"3S6Uf\",\"initialize.90dbe0f5.js\",\"43hsF\",\"EditorLoader.3bbaa98d.js\",\"710vD\",\"editor.8e47d073.js\",\"9Cer0\",\"editor-plugins.eb120b5a.js\",\"8MJT8\",\"editor-plugins.3f4d8630.js\",\"aqQdm\",\"editor-plugins.69121daf.css\",\"hZL0Z\",\"adg3-styles.0345a9dd.css\",\"kDJ6u\",\"wait.b55e6fef.gif\",\"lqsln\",\"warning.83e35a8f.png\",\"9ld2H\",\"ADG3-Editor-Icons.cc60d923.eot\",\"dwka9\",\"ADG3-Editor-Icons.c170c836.ttf\",\"h9OU0\",\"ADG3-Editor-Icons.45a9e586.woff\",\"aFaRR\",\"ADG3-Editor-Icons.529ae9e0.svg\",\"9tkO6\",\"adg3-styles.0dc93910.js\",\"dQy5b\",\"RedactedPlaceholder.d4316881.js\",\"iq6Zv\",\"experiment-legacy-content-macro.f9ffdb7e.js\",\"8JZKd\",\"activity.d586e3b7.js\",\"dI2vi\",\"extension-handler.4ad986d4.js\",\"80ixL\",\"task.23711132.js\",\"89jKa\",\"layout-two-equal.fb9a3b86.js\",\"7fpGq\",\"edit-filled.0fb73299.js\",\"gRc2J\",\"FullPageEditorComponent.1453a1a7.js\",\"17JTB\",\"modal.ab3296f0.js\",\"cMAQT\",\"DropboxIcon.91e2b52e.js\",\"aD89V\",\"dropbox.937005e0.js\",\"9n0AM\",\"dropboxscript.62f72250.js\",\"8AwXG\",\"ProjectLinker.e70271da.js\",\"j0KqR\",\"jira-board-light.49fc2d6c.png\",\"aEOsg\",\"jira-board-dark.4f2096de.png\",\"chv15\",\"jira-static-light.fe57e5bd.png\",\"5koHF\",\"jira-static-dark.ec3cbc0d.png\",\"gsg0E\",\"edit.069f757e.js\",\"RA3Jm\",\"layout-three-with-sidebars.0432df5a.js\",\"awJDd\",\"layout-two-left-sidebar.f2b26026.js\",\"bnitc\",\"layout-two-right-sidebar.649a39a4.js\",\"fdTog\",\"FullPageEditorComponent.4fb7d705.js\",\"eFHVS\",\"extensibility.bc55036e.js\",\"djfev\",\"ConfigPanelFieldsLoader.4cb08c72.js\",\"eoIpr\",\"add-circle.203cd6d7.js\",\"aotZe\",\"FullPageEditorComponent.1434306c.js\",\"2zD7d\",\"renderer-extension-handler.788a1535.js\",\"6IjKj\",\"TemplateVariableDialogComponent.669467e5.js\"]"));


//# sourceMappingURL=ClassicEditorContextProvider.7b0c1abe.js.map
